//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class AuthClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    requestCodeForProspect(request: ProspectCodeRequest): Observable<UserLoginInfo> {
        let url_ = this.baseUrl + "/Auth/request-code-prospect";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestCodeForProspect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestCodeForProspect(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserLoginInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserLoginInfo>;
        }));
    }

    protected processRequestCodeForProspect(response: HttpResponseBase): Observable<UserLoginInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserLoginInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    requestCodeForClient(request: ClientCodeRequest): Observable<UserLoginInfo> {
        let url_ = this.baseUrl + "/Auth/request-code-client";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestCodeForClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestCodeForClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserLoginInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserLoginInfo>;
        }));
    }

    protected processRequestCodeForClient(response: HttpResponseBase): Observable<UserLoginInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserLoginInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    validateCode(request: ValidateCodeRequest): Observable<TokenResponse> {
        let url_ = this.baseUrl + "/Auth/validate-code";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TokenResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TokenResponse>;
        }));
    }

    protected processValidateCode(response: HttpResponseBase): Observable<TokenResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TokenResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    resumeSession(request: ResumeSessionRequest): Observable<UserLoginInfo> {
        let url_ = this.baseUrl + "/Auth/resume-session";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResumeSession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResumeSession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserLoginInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserLoginInfo>;
        }));
    }

    protected processResumeSession(response: HttpResponseBase): Observable<UserLoginInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserLoginInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CustomerProfileClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    saveProfile(productCode: string, profileModel: Profile): Observable<Profile> {
        let url_ = this.baseUrl + "/CustomerProfile/{productCode}/save";
        if (productCode === undefined || productCode === null)
            throw new globalThis.Error("The parameter 'productCode' must be defined.");
        url_ = url_.replace("{productCode}", encodeURIComponent("" + productCode));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(profileModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Profile>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Profile>;
        }));
    }

    protected processSaveProfile(response: HttpResponseBase): Observable<Profile> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Profile.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUserData(profileId: string): Observable<Profile> {
        let url_ = this.baseUrl + "/CustomerProfile/get/{profileId}";
        if (profileId === undefined || profileId === null)
            throw new globalThis.Error("The parameter 'profileId' must be defined.");
        url_ = url_.replace("{profileId}", encodeURIComponent("" + profileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Profile>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Profile>;
        }));
    }

    protected processGetUserData(response: HttpResponseBase): Observable<Profile> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Profile.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getClient(clientNumber: string): Observable<Profile> {
        let url_ = this.baseUrl + "/CustomerProfile/import-external-client/{clientNumber}";
        if (clientNumber === undefined || clientNumber === null)
            throw new globalThis.Error("The parameter 'clientNumber' must be defined.");
        url_ = url_.replace("{clientNumber}", encodeURIComponent("" + clientNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Profile>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Profile>;
        }));
    }

    protected processGetClient(response: HttpResponseBase): Observable<Profile> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Profile.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getFile(fileUniqueId: string): Observable<File> {
        let url_ = this.baseUrl + "/CustomerProfile/get-file/{fileUniqueId}";
        if (fileUniqueId === undefined || fileUniqueId === null)
            throw new globalThis.Error("The parameter 'fileUniqueId' must be defined.");
        url_ = url_.replace("{fileUniqueId}", encodeURIComponent("" + fileUniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<File>;
                }
            } else
                return _observableThrow(response_) as any as Observable<File>;
        }));
    }

    protected processGetFile(response: HttpResponseBase): Observable<File> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = File.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSignedDocument(profileId: string): Observable<File> {
        let url_ = this.baseUrl + "/CustomerProfile/signed-document/{profileId}";
        if (profileId === undefined || profileId === null)
            throw new globalThis.Error("The parameter 'profileId' must be defined.");
        url_ = url_.replace("{profileId}", encodeURIComponent("" + profileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSignedDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSignedDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<File>;
                }
            } else
                return _observableThrow(response_) as any as Observable<File>;
        }));
    }

    protected processGetSignedDocument(response: HttpResponseBase): Observable<File> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = File.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateProfileDocuments(profileId: string, profileDocuments: ProfileDocument[]): Observable<ProfileDocument[]> {
        let url_ = this.baseUrl + "/CustomerProfile/update-profile-documents/{profileId}";
        if (profileId === undefined || profileId === null)
            throw new globalThis.Error("The parameter 'profileId' must be defined.");
        url_ = url_.replace("{profileId}", encodeURIComponent("" + profileId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(profileDocuments);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProfileDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProfileDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfileDocument[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfileDocument[]>;
        }));
    }

    protected processUpdateProfileDocuments(response: HttpResponseBase): Observable<ProfileDocument[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProfileDocument.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateAssetDocuments(profileId: string, proofOfFund: ProofOfFund[]): Observable<ProofOfFund[]> {
        let url_ = this.baseUrl + "/CustomerProfile/update-proof-of-fund-documents/{profileId}";
        if (profileId === undefined || profileId === null)
            throw new globalThis.Error("The parameter 'profileId' must be defined.");
        url_ = url_.replace("{profileId}", encodeURIComponent("" + profileId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(proofOfFund);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAssetDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAssetDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProofOfFund[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProofOfFund[]>;
        }));
    }

    protected processUpdateAssetDocuments(response: HttpResponseBase): Observable<ProofOfFund[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProofOfFund.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    signDocument(request: DocumentSignatureRequest): Observable<SignatureTransactionResponse> {
        let url_ = this.baseUrl + "/CustomerProfile/sign-document";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSignDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSignDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SignatureTransactionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SignatureTransactionResponse>;
        }));
    }

    protected processSignDocument(response: HttpResponseBase): Observable<SignatureTransactionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SignatureTransactionResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    retrySigningDocument(request: RetrySigningDocumentRequest): Observable<SignatureTransactionResponse> {
        let url_ = this.baseUrl + "/CustomerProfile/retry-signing-document";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrySigningDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrySigningDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SignatureTransactionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SignatureTransactionResponse>;
        }));
    }

    protected processRetrySigningDocument(response: HttpResponseBase): Observable<SignatureTransactionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SignatureTransactionResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    validateTransaction(transaction: SignatureTransactionRequest): Observable<SignatureTransactionResponse> {
        let url_ = this.baseUrl + "/CustomerProfile/validate-signature-transaction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(transaction);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateTransaction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateTransaction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SignatureTransactionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SignatureTransactionResponse>;
        }));
    }

    protected processValidateTransaction(response: HttpResponseBase): Observable<SignatureTransactionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SignatureTransactionResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSubscriptionContract(htmlContent: string): Observable<string> {
        let url_ = this.baseUrl + "/CustomerProfile/get-subscription-contract";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(htmlContent);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSubscriptionContract(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubscriptionContract(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetSubscriptionContract(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendOTP(profileId: string): Observable<SecurityServiceResponse> {
        let url_ = this.baseUrl + "/CustomerProfile/send-otp/{profileId}";
        if (profileId === undefined || profileId === null)
            throw new globalThis.Error("The parameter 'profileId' must be defined.");
        url_ = url_.replace("{profileId}", encodeURIComponent("" + profileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendOTP(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendOTP(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SecurityServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SecurityServiceResponse>;
        }));
    }

    protected processSendOTP(response: HttpResponseBase): Observable<SecurityServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SecurityServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    reSendOTP(request: ReSendOtpRequest): Observable<SecurityServiceResponse> {
        let url_ = this.baseUrl + "/CustomerProfile/resend-otp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReSendOTP(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReSendOTP(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SecurityServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SecurityServiceResponse>;
        }));
    }

    protected processReSendOTP(response: HttpResponseBase): Observable<SecurityServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SecurityServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    checkOTP(profileId: string, transactionId: string | undefined, signatoryId: string | undefined, otp: string | undefined): Observable<SecurityServiceResponse> {
        let url_ = this.baseUrl + "/CustomerProfile/check-otp/{profileId}?";
        if (profileId === undefined || profileId === null)
            throw new globalThis.Error("The parameter 'profileId' must be defined.");
        url_ = url_.replace("{profileId}", encodeURIComponent("" + profileId));
        if (transactionId === null)
            throw new globalThis.Error("The parameter 'transactionId' cannot be null.");
        else if (transactionId !== undefined)
            url_ += "transactionId=" + encodeURIComponent("" + transactionId) + "&";
        if (signatoryId === null)
            throw new globalThis.Error("The parameter 'signatoryId' cannot be null.");
        else if (signatoryId !== undefined)
            url_ += "signatoryId=" + encodeURIComponent("" + signatoryId) + "&";
        if (otp === null)
            throw new globalThis.Error("The parameter 'otp' cannot be null.");
        else if (otp !== undefined)
            url_ += "otp=" + encodeURIComponent("" + otp) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckOTP(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckOTP(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SecurityServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SecurityServiceResponse>;
        }));
    }

    protected processCheckOTP(response: HttpResponseBase): Observable<SecurityServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SecurityServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LabelsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getLabels(): Observable<Label[]> {
        let url_ = this.baseUrl + "/Labels/get-labels";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLabels(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLabels(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Label[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Label[]>;
        }));
    }

    protected processGetLabels(response: HttpResponseBase): Observable<Label[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Label.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateLabel(label: Label): Observable<FileResponse> {
        let url_ = this.baseUrl + "/Labels/update-label";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(label);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLabel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLabel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processUpdateLabel(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ReportingClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    recommendationReport(year: number): Observable<ReportFile> {
        let url_ = this.baseUrl + "/Reporting/recommendation-report/{year}";
        if (year === undefined || year === null)
            throw new globalThis.Error("The parameter 'year' must be defined.");
        url_ = url_.replace("{year}", encodeURIComponent("" + year));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRecommendationReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRecommendationReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportFile>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportFile>;
        }));
    }

    protected processRecommendationReport(response: HttpResponseBase): Observable<ReportFile> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportFile.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SettingsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getGpaConfiguration(): Observable<GpaConfiguration> {
        let url_ = this.baseUrl + "/Settings/gpa";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGpaConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGpaConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GpaConfiguration>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GpaConfiguration>;
        }));
    }

    protected processGetGpaConfiguration(response: HttpResponseBase): Observable<GpaConfiguration> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GpaConfiguration.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveGpaConfiguration(settings: GpaConfiguration): Observable<GpaConfiguration> {
        let url_ = this.baseUrl + "/Settings/gpa";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(settings);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveGpaConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveGpaConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GpaConfiguration>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GpaConfiguration>;
        }));
    }

    protected processSaveGpaConfiguration(response: HttpResponseBase): Observable<GpaConfiguration> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GpaConfiguration.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getGeneralConfiguration(): Observable<General> {
        let url_ = this.baseUrl + "/Settings/general";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGeneralConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGeneralConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<General>;
                }
            } else
                return _observableThrow(response_) as any as Observable<General>;
        }));
    }

    protected processGetGeneralConfiguration(response: HttpResponseBase): Observable<General> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = General.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveGeneralConfiguration(settings: General): Observable<General> {
        let url_ = this.baseUrl + "/Settings/general";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(settings);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveGeneralConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveGeneralConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<General>;
                }
            } else
                return _observableThrow(response_) as any as Observable<General>;
        }));
    }

    protected processSaveGeneralConfiguration(response: HttpResponseBase): Observable<General> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = General.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getExternalServicesConfiguration(): Observable<ExternalServices> {
        let url_ = this.baseUrl + "/Settings/external-services";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExternalServicesConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExternalServicesConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalServices>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalServices>;
        }));
    }

    protected processGetExternalServicesConfiguration(response: HttpResponseBase): Observable<ExternalServices> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalServices.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveExternalServicesConfiguration(settings: ExternalServices): Observable<ExternalServices> {
        let url_ = this.baseUrl + "/Settings/external-services";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(settings);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveExternalServicesConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveExternalServicesConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalServices>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalServices>;
        }));
    }

    protected processSaveExternalServicesConfiguration(response: HttpResponseBase): Observable<ExternalServices> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalServices.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSubscriptionConfiguration(): Observable<Subscription> {
        let url_ = this.baseUrl + "/Settings/subscription";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSubscriptionConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubscriptionConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Subscription>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Subscription>;
        }));
    }

    protected processGetSubscriptionConfiguration(response: HttpResponseBase): Observable<Subscription> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Subscription.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveSubscriptionConfiguration(settings: Subscription): Observable<Subscription> {
        let url_ = this.baseUrl + "/Settings/subscription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(settings);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveSubscriptionConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveSubscriptionConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Subscription>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Subscription>;
        }));
    }

    protected processSaveSubscriptionConfiguration(response: HttpResponseBase): Observable<Subscription> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Subscription.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getBeneficiariesConfiguration(): Observable<Beneficiaries> {
        let url_ = this.baseUrl + "/Settings/beneficiaries";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBeneficiariesConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBeneficiariesConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Beneficiaries>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Beneficiaries>;
        }));
    }

    protected processGetBeneficiariesConfiguration(response: HttpResponseBase): Observable<Beneficiaries> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Beneficiaries.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveBeneficiariesConfiguration(settings: Beneficiaries): Observable<Beneficiaries> {
        let url_ = this.baseUrl + "/Settings/beneficiaries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(settings);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveBeneficiariesConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveBeneficiariesConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Beneficiaries>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Beneficiaries>;
        }));
    }

    protected processSaveBeneficiariesConfiguration(response: HttpResponseBase): Observable<Beneficiaries> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Beneficiaries.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSummaryConfiguration(): Observable<Summary> {
        let url_ = this.baseUrl + "/Settings/summary";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSummaryConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSummaryConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Summary>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Summary>;
        }));
    }

    protected processGetSummaryConfiguration(response: HttpResponseBase): Observable<Summary> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Summary.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveSummaryConfiguration(settings: Summary): Observable<Summary> {
        let url_ = this.baseUrl + "/Settings/summary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(settings);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveSummaryConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveSummaryConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Summary>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Summary>;
        }));
    }

    protected processSaveSummaryConfiguration(response: HttpResponseBase): Observable<Summary> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Summary.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSepaMandateConfiguration(): Observable<SepaMandate> {
        let url_ = this.baseUrl + "/Settings/sepa-mandate";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSepaMandateConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSepaMandateConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SepaMandate>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SepaMandate>;
        }));
    }

    protected processGetSepaMandateConfiguration(response: HttpResponseBase): Observable<SepaMandate> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SepaMandate.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveSepaMandateConfiguration(settings: SepaMandate): Observable<SepaMandate> {
        let url_ = this.baseUrl + "/Settings/sepa-mandate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(settings);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveSepaMandateConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveSepaMandateConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SepaMandate>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SepaMandate>;
        }));
    }

    protected processSaveSepaMandateConfiguration(response: HttpResponseBase): Observable<SepaMandate> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SepaMandate.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEmailsConfiguration(): Observable<Emails> {
        let url_ = this.baseUrl + "/Settings/emails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmailsConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmailsConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Emails>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Emails>;
        }));
    }

    protected processGetEmailsConfiguration(response: HttpResponseBase): Observable<Emails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Emails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveEmailsConfiguration(settings: Emails): Observable<Emails> {
        let url_ = this.baseUrl + "/Settings/emails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(settings);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveEmailsConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveEmailsConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Emails>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Emails>;
        }));
    }

    protected processSaveEmailsConfiguration(response: HttpResponseBase): Observable<Emails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Emails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getQuestionnaireConfiguration(): Observable<Questionnaire> {
        let url_ = this.baseUrl + "/Settings/questionnaire";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQuestionnaireConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQuestionnaireConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Questionnaire>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Questionnaire>;
        }));
    }

    protected processGetQuestionnaireConfiguration(response: HttpResponseBase): Observable<Questionnaire> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Questionnaire.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveQuestionnaireConfiguration(settings: Questionnaire): Observable<Questionnaire> {
        let url_ = this.baseUrl + "/Settings/questionnaire";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(settings);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveQuestionnaireConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveQuestionnaireConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Questionnaire>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Questionnaire>;
        }));
    }

    protected processSaveQuestionnaireConfiguration(response: HttpResponseBase): Observable<Questionnaire> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Questionnaire.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDefaultProductTabsConfiguration(): Observable<DefaultProductTabs> {
        let url_ = this.baseUrl + "/Settings/default-product-tabs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDefaultProductTabsConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDefaultProductTabsConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DefaultProductTabs>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DefaultProductTabs>;
        }));
    }

    protected processGetDefaultProductTabsConfiguration(response: HttpResponseBase): Observable<DefaultProductTabs> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DefaultProductTabs.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveDefaultProductTabsConfiguration(settings: DefaultProductTabs): Observable<DefaultProductTabs> {
        let url_ = this.baseUrl + "/Settings/default-product-tabs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(settings);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveDefaultProductTabsConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveDefaultProductTabsConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DefaultProductTabs>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DefaultProductTabs>;
        }));
    }

    protected processSaveDefaultProductTabsConfiguration(response: HttpResponseBase): Observable<DefaultProductTabs> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DefaultProductTabs.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getProductTabsConfiguration(): Observable<ProductTabs> {
        let url_ = this.baseUrl + "/Settings/product-tabs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductTabsConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductTabsConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductTabs>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductTabs>;
        }));
    }

    protected processGetProductTabsConfiguration(response: HttpResponseBase): Observable<ProductTabs> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductTabs.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveProductTabsConfiguration(settings: ProductTabs): Observable<ProductTabs> {
        let url_ = this.baseUrl + "/Settings/product-tabs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(settings);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveProductTabsConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveProductTabsConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductTabs>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductTabs>;
        }));
    }

    protected processSaveProductTabsConfiguration(response: HttpResponseBase): Observable<ProductTabs> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductTabs.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPaymentsConfiguration(): Observable<Payments> {
        let url_ = this.baseUrl + "/Settings/payments";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentsConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentsConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Payments>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Payments>;
        }));
    }

    protected processGetPaymentsConfiguration(response: HttpResponseBase): Observable<Payments> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Payments.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    savePaymentsConfiguration(settings: Payments): Observable<Payments> {
        let url_ = this.baseUrl + "/Settings/payments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(settings);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSavePaymentsConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSavePaymentsConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Payments>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Payments>;
        }));
    }

    protected processSavePaymentsConfiguration(response: HttpResponseBase): Observable<Payments> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Payments.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getContractTransferConfiguration(): Observable<ContractTransfer> {
        let url_ = this.baseUrl + "/Settings/contract-transfer";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContractTransferConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContractTransferConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContractTransfer>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContractTransfer>;
        }));
    }

    protected processGetContractTransferConfiguration(response: HttpResponseBase): Observable<ContractTransfer> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContractTransfer.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveContractTransferConfiguration(settings: ContractTransfer): Observable<ContractTransfer> {
        let url_ = this.baseUrl + "/Settings/contract-transfer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(settings);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveContractTransferConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveContractTransferConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContractTransfer>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContractTransfer>;
        }));
    }

    protected processSaveContractTransferConfiguration(response: HttpResponseBase): Observable<ContractTransfer> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContractTransfer.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getFundsOriginConfiguration(): Observable<FundsOrigin> {
        let url_ = this.baseUrl + "/Settings/funds-origin";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFundsOriginConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFundsOriginConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FundsOrigin>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FundsOrigin>;
        }));
    }

    protected processGetFundsOriginConfiguration(response: HttpResponseBase): Observable<FundsOrigin> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FundsOrigin.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveFundsOriginConfiguration(settings: FundsOrigin): Observable<FundsOrigin> {
        let url_ = this.baseUrl + "/Settings/funds-origin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(settings);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveFundsOriginConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveFundsOriginConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FundsOrigin>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FundsOrigin>;
        }));
    }

    protected processSaveFundsOriginConfiguration(response: HttpResponseBase): Observable<FundsOrigin> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FundsOrigin.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSubscriptionWithdrawalConfiguration(): Observable<SubscriptionWithdrawal> {
        let url_ = this.baseUrl + "/Settings/withdrawal";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSubscriptionWithdrawalConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubscriptionWithdrawalConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubscriptionWithdrawal>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubscriptionWithdrawal>;
        }));
    }

    protected processGetSubscriptionWithdrawalConfiguration(response: HttpResponseBase): Observable<SubscriptionWithdrawal> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubscriptionWithdrawal.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveSubscriptionWithdrawalConfiguration(settings: SubscriptionWithdrawal): Observable<SubscriptionWithdrawal> {
        let url_ = this.baseUrl + "/Settings/withdrawal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(settings);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveSubscriptionWithdrawalConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveSubscriptionWithdrawalConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubscriptionWithdrawal>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubscriptionWithdrawal>;
        }));
    }

    protected processSaveSubscriptionWithdrawalConfiguration(response: HttpResponseBase): Observable<SubscriptionWithdrawal> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubscriptionWithdrawal.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTemplateByProduct(productId: number): Observable<EmailTemplate[]> {
        let url_ = this.baseUrl + "/Settings/get-template-by-product/{productId}";
        if (productId === undefined || productId === null)
            throw new globalThis.Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTemplateByProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTemplateByProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmailTemplate[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmailTemplate[]>;
        }));
    }

    protected processGetTemplateByProduct(response: HttpResponseBase): Observable<EmailTemplate[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmailTemplate.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    restoreOriginal(id: number): Observable<EmailTemplate> {
        let url_ = this.baseUrl + "/Settings/restore-original-template/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRestoreOriginal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRestoreOriginal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmailTemplate>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmailTemplate>;
        }));
    }

    protected processRestoreOriginal(response: HttpResponseBase): Observable<EmailTemplate> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmailTemplate.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateTemplate(template: EmailTemplate): Observable<EmailTemplate> {
        let url_ = this.baseUrl + "/Settings/update-template";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(template);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmailTemplate>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmailTemplate>;
        }));
    }

    protected processUpdateTemplate(response: HttpResponseBase): Observable<EmailTemplate> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmailTemplate.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateAssociatedQuestions(model: AssociatedQuestion[]): Observable<AssociatedQuestion[]> {
        let url_ = this.baseUrl + "/Settings/update-associated-questions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAssociatedQuestions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAssociatedQuestions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssociatedQuestion[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssociatedQuestion[]>;
        }));
    }

    protected processUpdateAssociatedQuestions(response: HttpResponseBase): Observable<AssociatedQuestion[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssociatedQuestion.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAssociatedQuestions(): Observable<AssociatedQuestion[]> {
        let url_ = this.baseUrl + "/Settings/get-associated-questions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssociatedQuestions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssociatedQuestions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssociatedQuestion[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssociatedQuestion[]>;
        }));
    }

    protected processGetAssociatedQuestions(response: HttpResponseBase): Observable<AssociatedQuestion[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssociatedQuestion.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getInvestmentLimitConfiguration(): Observable<InvestmentLimits> {
        let url_ = this.baseUrl + "/Settings/get-investment-limit";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvestmentLimitConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvestmentLimitConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvestmentLimits>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvestmentLimits>;
        }));
    }

    protected processGetInvestmentLimitConfiguration(response: HttpResponseBase): Observable<InvestmentLimits> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvestmentLimits.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveInvestmentLimitConfiguration(settings: InvestmentLimits): Observable<InvestmentLimits> {
        let url_ = this.baseUrl + "/Settings/investment-limit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(settings);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveInvestmentLimitConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveInvestmentLimitConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvestmentLimits>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvestmentLimits>;
        }));
    }

    protected processSaveInvestmentLimitConfiguration(response: HttpResponseBase): Observable<InvestmentLimits> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvestmentLimits.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LookupsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getOfferStatuses(): Observable<OfferStatus[]> {
        let url_ = this.baseUrl + "/Lookups/statuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOfferStatuses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOfferStatuses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OfferStatus[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OfferStatus[]>;
        }));
    }

    protected processGetOfferStatuses(response: HttpResponseBase): Observable<OfferStatus[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OfferStatus.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getProducts(): Observable<Product[]> {
        let url_ = this.baseUrl + "/Lookups/products";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProducts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Product[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Product[]>;
        }));
    }

    protected processGetProducts(response: HttpResponseBase): Observable<Product[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Product.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSectionTypes(): Observable<Section[]> {
        let url_ = this.baseUrl + "/Lookups/section-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSectionTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSectionTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Section[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Section[]>;
        }));
    }

    protected processGetSectionTypes(response: HttpResponseBase): Observable<Section[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Section.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSections(groupType: GroupType): Observable<Section[]> {
        let url_ = this.baseUrl + "/Lookups/sections/{groupType}";
        if (groupType === undefined || groupType === null)
            throw new globalThis.Error("The parameter 'groupType' must be defined.");
        url_ = url_.replace("{groupType}", encodeURIComponent("" + groupType));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSections(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSections(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Section[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Section[]>;
        }));
    }

    protected processGetSections(response: HttpResponseBase): Observable<Section[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Section.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getConditionTypes(): Observable<ConditionType[]> {
        let url_ = this.baseUrl + "/Lookups/condition-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConditionTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConditionTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConditionType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConditionType[]>;
        }));
    }

    protected processGetConditionTypes(response: HttpResponseBase): Observable<ConditionType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConditionType.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getConditionValues(): Observable<OptionValue[]> {
        let url_ = this.baseUrl + "/Lookups/condition-values";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConditionValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConditionValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OptionValue[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OptionValue[]>;
        }));
    }

    protected processGetConditionValues(response: HttpResponseBase): Observable<OptionValue[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OptionValue.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MonitoringClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getWithdrawnSubscriptions(): Observable<WithdrawnSubscriptionsResponse> {
        let url_ = this.baseUrl + "/Monitoring/get-withdrawn-subscriptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWithdrawnSubscriptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWithdrawnSubscriptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WithdrawnSubscriptionsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WithdrawnSubscriptionsResponse>;
        }));
    }

    protected processGetWithdrawnSubscriptions(response: HttpResponseBase): Observable<WithdrawnSubscriptionsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WithdrawnSubscriptionsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class OffersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAllOffers(): Observable<Offer[]> {
        let url_ = this.baseUrl + "/Offers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllOffers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllOffers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Offer[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Offer[]>;
        }));
    }

    protected processGetAllOffers(response: HttpResponseBase): Observable<Offer[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Offer.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(offer: Offer): Observable<Offer> {
        let url_ = this.baseUrl + "/Offers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(offer);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Offer>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Offer>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<Offer> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Offer.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getById(id: number): Observable<Offer> {
        let url_ = this.baseUrl + "/Offers/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Offer>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Offer>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<Offer> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Offer.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(id: number, offer: Offer): Observable<Offer> {
        let url_ = this.baseUrl + "/Offers/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(offer);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Offer>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Offer>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<Offer> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Offer.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id: number): Observable<number> {
        let url_ = this.baseUrl + "/Offers/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    changeHistory(id: number): Observable<ChangeHistory[]> {
        let url_ = this.baseUrl + "/Offers/change-history/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChangeHistory[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChangeHistory[]>;
        }));
    }

    protected processChangeHistory(response: HttpResponseBase): Observable<ChangeHistory[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChangeHistory.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PortfolioClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getPortfolioPerformance(): Observable<PortfolioPerformance[]> {
        let url_ = this.baseUrl + "/Portfolio/performance";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPortfolioPerformance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPortfolioPerformance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PortfolioPerformance[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PortfolioPerformance[]>;
        }));
    }

    protected processGetPortfolioPerformance(response: HttpResponseBase): Observable<PortfolioPerformance[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PortfolioPerformance.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    savePortfolioPerformance(portfolioPerformances: PortfolioPerformance[]): Observable<PortfolioPerformance[]> {
        let url_ = this.baseUrl + "/Portfolio/performance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(portfolioPerformances);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSavePortfolioPerformance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSavePortfolioPerformance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PortfolioPerformance[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PortfolioPerformance[]>;
        }));
    }

    protected processSavePortfolioPerformance(response: HttpResponseBase): Observable<PortfolioPerformance[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PortfolioPerformance.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class UserLoginInfo implements IUserLoginInfo {
    sessionId?: string;
    email?: string;
    phoneNumber?: string;

    constructor(data?: IUserLoginInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionId = _data["sessionId"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): UserLoginInfo {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionId"] = this.sessionId;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface IUserLoginInfo {
    sessionId?: string;
    email?: string;
    phoneNumber?: string;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class ProspectCodeRequest implements IProspectCodeRequest {
    phoneNumber!: string;
    email!: string;
    deliveryMode?: AuthorizationDeliveryMode | undefined;

    constructor(data?: IProspectCodeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneNumber = _data["phoneNumber"];
            this.email = _data["email"];
            this.deliveryMode = _data["deliveryMode"];
        }
    }

    static fromJS(data: any): ProspectCodeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ProspectCodeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        data["deliveryMode"] = this.deliveryMode;
        return data;
    }
}

export interface IProspectCodeRequest {
    phoneNumber: string;
    email: string;
    deliveryMode?: AuthorizationDeliveryMode | undefined;
}

export enum AuthorizationDeliveryMode {
    Sms = 1,
    Email = 2,
}

export class ClientCodeRequest implements IClientCodeRequest {
    clientId!: string;
    dateOfBirth!: Date;
    deliveryMode?: AuthorizationDeliveryMode | undefined;

    constructor(data?: IClientCodeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : undefined as any;
            this.deliveryMode = _data["deliveryMode"];
        }
    }

    static fromJS(data: any): ClientCodeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ClientCodeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["dateOfBirth"] = this.dateOfBirth ? formatDate(this.dateOfBirth) : undefined as any;
        data["deliveryMode"] = this.deliveryMode;
        return data;
    }
}

export interface IClientCodeRequest {
    clientId: string;
    dateOfBirth: Date;
    deliveryMode?: AuthorizationDeliveryMode | undefined;
}

export class TokenResponse implements ITokenResponse {
    accessToken?: string;
    expiresAtUtc?: Date;

    constructor(data?: ITokenResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.expiresAtUtc = _data["expiresAtUtc"] ? new Date(_data["expiresAtUtc"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): TokenResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TokenResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["expiresAtUtc"] = this.expiresAtUtc ? this.expiresAtUtc.toISOString() : undefined as any;
        return data;
    }
}

export interface ITokenResponse {
    accessToken?: string;
    expiresAtUtc?: Date;
}

export class ValidateCodeRequest implements IValidateCodeRequest {
    sessionId?: string;
    code?: string;

    constructor(data?: IValidateCodeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionId = _data["sessionId"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ValidateCodeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateCodeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionId"] = this.sessionId;
        data["code"] = this.code;
        return data;
    }
}

export interface IValidateCodeRequest {
    sessionId?: string;
    code?: string;
}

export class ResumeSessionRequest implements IResumeSessionRequest {
    profileId!: string;
    deliveryMode?: AuthorizationDeliveryMode | undefined;

    constructor(data?: IResumeSessionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profileId = _data["profileId"];
            this.deliveryMode = _data["deliveryMode"];
        }
    }

    static fromJS(data: any): ResumeSessionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResumeSessionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profileId"] = this.profileId;
        data["deliveryMode"] = this.deliveryMode;
        return data;
    }
}

export interface IResumeSessionRequest {
    profileId: string;
    deliveryMode?: AuthorizationDeliveryMode | undefined;
}

export class Profile implements IProfile {
    uniqueId?: string;
    person?: Person | undefined;
    gpaProfile?: GpaProfile | undefined;
    gfdProfile?: GfdProfile | undefined;
    cimsProfile?: CimsProfile | undefined;
    professionalInfo?: ProfessionalInfo | undefined;
    profileQuestions?: ProfileQuestion[];
    beneficiaries?: Beneficiary[];
    profileFunds?: ProfileFund[];
    profileDocuments?: ProfileDocument[];
    proofOfFunds?: ProofOfFund[];
    advertisementSource?: AdvertisementSource | undefined;
    createdOn?: Date | undefined;
    beneficiaryClauseCode?: number | undefined;
    isFrenchTaxResident?: boolean | undefined;
    isUsCitizen?: boolean | undefined;
    isLegallyCapable?: boolean | undefined;
    doTransferContract?: boolean | undefined;
    transferContractCode?: number | undefined;
    transferContractAmount?: number | undefined;
    initialPaymentAmount?: number | undefined;
    scheduledPaymentAmount?: number | undefined;
    placeOfBirth?: Address | undefined;
    currentAddress?: Address | undefined;
    contact?: Contact | undefined;
    profileAssets?: ProfileAssets | undefined;
    profileStepCode?: string | undefined;
    recommendedInvestmentProfileId?: number | undefined;
    selectedInvestmentProfileId?: number | undefined;
    socialNumberA?: string | undefined;
    socialNumberB?: string | undefined;
    maritalStatusCode?: number | undefined;
    matrimonialRegimeCode?: number | undefined;
    politicalStatusCode?: number | undefined;
    politicalStatusCategoryCode?: number | undefined;
    politicalStatusValue?: number | undefined;
    isDefaultBeneficiaryInheritance?: boolean | undefined;
    iban?: string | undefined;
    bic?: string | undefined;
    rum?: string | undefined;
    nir?: string | undefined;
    isRecommendationsFollowed?: boolean | undefined;
    isMember?: boolean | undefined;
    profileTypeCode?: number | undefined;
    managementTypeCode?: number | undefined;
    beneficiaryFreeClauseText?: string | undefined;
    recommendationText?: string | undefined;
    fileNumber?: string | undefined;
    productCode?: string | undefined;
    contractNumber?: string | undefined;
    useExistingRum?: boolean;
    score?: number | undefined;
    questionnaireIdentifier?: number | undefined;
    profileStatus?: ProfileStatus | undefined;
    retirementPlan?: RetirementPlan | undefined;

    constructor(data?: IProfile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : undefined as any;
            this.gpaProfile = _data["gpaProfile"] ? GpaProfile.fromJS(_data["gpaProfile"]) : undefined as any;
            this.gfdProfile = _data["gfdProfile"] ? GfdProfile.fromJS(_data["gfdProfile"]) : undefined as any;
            this.cimsProfile = _data["cimsProfile"] ? CimsProfile.fromJS(_data["cimsProfile"]) : undefined as any;
            this.professionalInfo = _data["professionalInfo"] ? ProfessionalInfo.fromJS(_data["professionalInfo"]) : undefined as any;
            if (Array.isArray(_data["profileQuestions"])) {
                this.profileQuestions = [] as any;
                for (let item of _data["profileQuestions"])
                    this.profileQuestions!.push(ProfileQuestion.fromJS(item));
            }
            if (Array.isArray(_data["beneficiaries"])) {
                this.beneficiaries = [] as any;
                for (let item of _data["beneficiaries"])
                    this.beneficiaries!.push(Beneficiary.fromJS(item));
            }
            if (Array.isArray(_data["profileFunds"])) {
                this.profileFunds = [] as any;
                for (let item of _data["profileFunds"])
                    this.profileFunds!.push(ProfileFund.fromJS(item));
            }
            if (Array.isArray(_data["profileDocuments"])) {
                this.profileDocuments = [] as any;
                for (let item of _data["profileDocuments"])
                    this.profileDocuments!.push(ProfileDocument.fromJS(item));
            }
            if (Array.isArray(_data["proofOfFunds"])) {
                this.proofOfFunds = [] as any;
                for (let item of _data["proofOfFunds"])
                    this.proofOfFunds!.push(ProofOfFund.fromJS(item));
            }
            this.advertisementSource = _data["advertisementSource"] ? AdvertisementSource.fromJS(_data["advertisementSource"]) : undefined as any;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.beneficiaryClauseCode = _data["beneficiaryClauseCode"];
            this.isFrenchTaxResident = _data["isFrenchTaxResident"];
            this.isUsCitizen = _data["isUsCitizen"];
            this.isLegallyCapable = _data["isLegallyCapable"];
            this.doTransferContract = _data["doTransferContract"];
            this.transferContractCode = _data["transferContractCode"];
            this.transferContractAmount = _data["transferContractAmount"];
            this.initialPaymentAmount = _data["initialPaymentAmount"];
            this.scheduledPaymentAmount = _data["scheduledPaymentAmount"];
            this.placeOfBirth = _data["placeOfBirth"] ? Address.fromJS(_data["placeOfBirth"]) : undefined as any;
            this.currentAddress = _data["currentAddress"] ? Address.fromJS(_data["currentAddress"]) : undefined as any;
            this.contact = _data["contact"] ? Contact.fromJS(_data["contact"]) : undefined as any;
            this.profileAssets = _data["profileAssets"] ? ProfileAssets.fromJS(_data["profileAssets"]) : undefined as any;
            this.profileStepCode = _data["profileStepCode"];
            this.recommendedInvestmentProfileId = _data["recommendedInvestmentProfileId"];
            this.selectedInvestmentProfileId = _data["selectedInvestmentProfileId"];
            this.socialNumberA = _data["socialNumberA"];
            this.socialNumberB = _data["socialNumberB"];
            this.maritalStatusCode = _data["maritalStatusCode"];
            this.matrimonialRegimeCode = _data["matrimonialRegimeCode"];
            this.politicalStatusCode = _data["politicalStatusCode"];
            this.politicalStatusCategoryCode = _data["politicalStatusCategoryCode"];
            this.politicalStatusValue = _data["politicalStatusValue"];
            this.isDefaultBeneficiaryInheritance = _data["isDefaultBeneficiaryInheritance"];
            this.iban = _data["iban"];
            this.bic = _data["bic"];
            this.rum = _data["rum"];
            this.nir = _data["nir"];
            this.isRecommendationsFollowed = _data["isRecommendationsFollowed"];
            this.isMember = _data["isMember"];
            this.profileTypeCode = _data["profileTypeCode"];
            this.managementTypeCode = _data["managementTypeCode"];
            this.beneficiaryFreeClauseText = _data["beneficiaryFreeClauseText"];
            this.recommendationText = _data["recommendationText"];
            this.fileNumber = _data["fileNumber"];
            this.productCode = _data["productCode"];
            this.contractNumber = _data["contractNumber"];
            this.useExistingRum = _data["useExistingRum"];
            this.score = _data["score"];
            this.questionnaireIdentifier = _data["questionnaireIdentifier"];
            this.profileStatus = _data["profileStatus"];
            this.retirementPlan = _data["retirementPlan"] ? RetirementPlan.fromJS(_data["retirementPlan"]) : undefined as any;
        }
    }

    static fromJS(data: any): Profile {
        data = typeof data === 'object' ? data : {};
        let result = new Profile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["person"] = this.person ? this.person.toJSON() : undefined as any;
        data["gpaProfile"] = this.gpaProfile ? this.gpaProfile.toJSON() : undefined as any;
        data["gfdProfile"] = this.gfdProfile ? this.gfdProfile.toJSON() : undefined as any;
        data["cimsProfile"] = this.cimsProfile ? this.cimsProfile.toJSON() : undefined as any;
        data["professionalInfo"] = this.professionalInfo ? this.professionalInfo.toJSON() : undefined as any;
        if (Array.isArray(this.profileQuestions)) {
            data["profileQuestions"] = [];
            for (let item of this.profileQuestions)
                data["profileQuestions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.beneficiaries)) {
            data["beneficiaries"] = [];
            for (let item of this.beneficiaries)
                data["beneficiaries"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.profileFunds)) {
            data["profileFunds"] = [];
            for (let item of this.profileFunds)
                data["profileFunds"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.profileDocuments)) {
            data["profileDocuments"] = [];
            for (let item of this.profileDocuments)
                data["profileDocuments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.proofOfFunds)) {
            data["proofOfFunds"] = [];
            for (let item of this.proofOfFunds)
                data["proofOfFunds"].push(item ? item.toJSON() : undefined as any);
        }
        data["advertisementSource"] = this.advertisementSource ? this.advertisementSource.toJSON() : undefined as any;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["beneficiaryClauseCode"] = this.beneficiaryClauseCode;
        data["isFrenchTaxResident"] = this.isFrenchTaxResident;
        data["isUsCitizen"] = this.isUsCitizen;
        data["isLegallyCapable"] = this.isLegallyCapable;
        data["doTransferContract"] = this.doTransferContract;
        data["transferContractCode"] = this.transferContractCode;
        data["transferContractAmount"] = this.transferContractAmount;
        data["initialPaymentAmount"] = this.initialPaymentAmount;
        data["scheduledPaymentAmount"] = this.scheduledPaymentAmount;
        data["placeOfBirth"] = this.placeOfBirth ? this.placeOfBirth.toJSON() : undefined as any;
        data["currentAddress"] = this.currentAddress ? this.currentAddress.toJSON() : undefined as any;
        data["contact"] = this.contact ? this.contact.toJSON() : undefined as any;
        data["profileAssets"] = this.profileAssets ? this.profileAssets.toJSON() : undefined as any;
        data["profileStepCode"] = this.profileStepCode;
        data["recommendedInvestmentProfileId"] = this.recommendedInvestmentProfileId;
        data["selectedInvestmentProfileId"] = this.selectedInvestmentProfileId;
        data["socialNumberA"] = this.socialNumberA;
        data["socialNumberB"] = this.socialNumberB;
        data["maritalStatusCode"] = this.maritalStatusCode;
        data["matrimonialRegimeCode"] = this.matrimonialRegimeCode;
        data["politicalStatusCode"] = this.politicalStatusCode;
        data["politicalStatusCategoryCode"] = this.politicalStatusCategoryCode;
        data["politicalStatusValue"] = this.politicalStatusValue;
        data["isDefaultBeneficiaryInheritance"] = this.isDefaultBeneficiaryInheritance;
        data["iban"] = this.iban;
        data["bic"] = this.bic;
        data["rum"] = this.rum;
        data["nir"] = this.nir;
        data["isRecommendationsFollowed"] = this.isRecommendationsFollowed;
        data["isMember"] = this.isMember;
        data["profileTypeCode"] = this.profileTypeCode;
        data["managementTypeCode"] = this.managementTypeCode;
        data["beneficiaryFreeClauseText"] = this.beneficiaryFreeClauseText;
        data["recommendationText"] = this.recommendationText;
        data["fileNumber"] = this.fileNumber;
        data["productCode"] = this.productCode;
        data["contractNumber"] = this.contractNumber;
        data["useExistingRum"] = this.useExistingRum;
        data["score"] = this.score;
        data["questionnaireIdentifier"] = this.questionnaireIdentifier;
        data["profileStatus"] = this.profileStatus;
        data["retirementPlan"] = this.retirementPlan ? this.retirementPlan.toJSON() : undefined as any;
        return data;
    }
}

export interface IProfile {
    uniqueId?: string;
    person?: Person | undefined;
    gpaProfile?: GpaProfile | undefined;
    gfdProfile?: GfdProfile | undefined;
    cimsProfile?: CimsProfile | undefined;
    professionalInfo?: ProfessionalInfo | undefined;
    profileQuestions?: ProfileQuestion[];
    beneficiaries?: Beneficiary[];
    profileFunds?: ProfileFund[];
    profileDocuments?: ProfileDocument[];
    proofOfFunds?: ProofOfFund[];
    advertisementSource?: AdvertisementSource | undefined;
    createdOn?: Date | undefined;
    beneficiaryClauseCode?: number | undefined;
    isFrenchTaxResident?: boolean | undefined;
    isUsCitizen?: boolean | undefined;
    isLegallyCapable?: boolean | undefined;
    doTransferContract?: boolean | undefined;
    transferContractCode?: number | undefined;
    transferContractAmount?: number | undefined;
    initialPaymentAmount?: number | undefined;
    scheduledPaymentAmount?: number | undefined;
    placeOfBirth?: Address | undefined;
    currentAddress?: Address | undefined;
    contact?: Contact | undefined;
    profileAssets?: ProfileAssets | undefined;
    profileStepCode?: string | undefined;
    recommendedInvestmentProfileId?: number | undefined;
    selectedInvestmentProfileId?: number | undefined;
    socialNumberA?: string | undefined;
    socialNumberB?: string | undefined;
    maritalStatusCode?: number | undefined;
    matrimonialRegimeCode?: number | undefined;
    politicalStatusCode?: number | undefined;
    politicalStatusCategoryCode?: number | undefined;
    politicalStatusValue?: number | undefined;
    isDefaultBeneficiaryInheritance?: boolean | undefined;
    iban?: string | undefined;
    bic?: string | undefined;
    rum?: string | undefined;
    nir?: string | undefined;
    isRecommendationsFollowed?: boolean | undefined;
    isMember?: boolean | undefined;
    profileTypeCode?: number | undefined;
    managementTypeCode?: number | undefined;
    beneficiaryFreeClauseText?: string | undefined;
    recommendationText?: string | undefined;
    fileNumber?: string | undefined;
    productCode?: string | undefined;
    contractNumber?: string | undefined;
    useExistingRum?: boolean;
    score?: number | undefined;
    questionnaireIdentifier?: number | undefined;
    profileStatus?: ProfileStatus | undefined;
    retirementPlan?: RetirementPlan | undefined;
}

export class Person implements IPerson {
    genderCode?: number | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    birthName?: string | undefined;
    dateOfBirth?: Date | undefined;
    civilityCode?: number | undefined;
    nationalityCode?: number | undefined;

    constructor(data?: IPerson) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.genderCode = _data["genderCode"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.birthName = _data["birthName"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : undefined as any;
            this.civilityCode = _data["civilityCode"];
            this.nationalityCode = _data["nationalityCode"];
        }
    }

    static fromJS(data: any): Person {
        data = typeof data === 'object' ? data : {};
        let result = new Person();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["genderCode"] = this.genderCode;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["birthName"] = this.birthName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : undefined as any;
        data["civilityCode"] = this.civilityCode;
        data["nationalityCode"] = this.nationalityCode;
        return data;
    }
}

export interface IPerson {
    genderCode?: number | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    birthName?: string | undefined;
    dateOfBirth?: Date | undefined;
    civilityCode?: number | undefined;
    nationalityCode?: number | undefined;
}

export class GpaProfile implements IGpaProfile {
    id?: number | undefined;
    isLaidOff?: boolean | undefined;
    isDysfunctional?: boolean | undefined;
    isOffWork?: boolean | undefined;
    isOnTreatment?: boolean | undefined;
    guaranteedCapitalCode?: number | undefined;
    isMultipliedCoverage?: boolean | undefined;
    monthlyPayment?: number | undefined;
    beneficiaryClauseCode?: number | undefined;
    beneficiaryFreeClauseText?: string | undefined;
    isDefaultBeneficiaryInheritance?: boolean | undefined;
    beneficiaries?: Beneficiary[] | undefined;

    constructor(data?: IGpaProfile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isLaidOff = _data["isLaidOff"];
            this.isDysfunctional = _data["isDysfunctional"];
            this.isOffWork = _data["isOffWork"];
            this.isOnTreatment = _data["isOnTreatment"];
            this.guaranteedCapitalCode = _data["guaranteedCapitalCode"];
            this.isMultipliedCoverage = _data["isMultipliedCoverage"];
            this.monthlyPayment = _data["monthlyPayment"];
            this.beneficiaryClauseCode = _data["beneficiaryClauseCode"];
            this.beneficiaryFreeClauseText = _data["beneficiaryFreeClauseText"];
            this.isDefaultBeneficiaryInheritance = _data["isDefaultBeneficiaryInheritance"];
            if (Array.isArray(_data["beneficiaries"])) {
                this.beneficiaries = [] as any;
                for (let item of _data["beneficiaries"])
                    this.beneficiaries!.push(Beneficiary.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GpaProfile {
        data = typeof data === 'object' ? data : {};
        let result = new GpaProfile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isLaidOff"] = this.isLaidOff;
        data["isDysfunctional"] = this.isDysfunctional;
        data["isOffWork"] = this.isOffWork;
        data["isOnTreatment"] = this.isOnTreatment;
        data["guaranteedCapitalCode"] = this.guaranteedCapitalCode;
        data["isMultipliedCoverage"] = this.isMultipliedCoverage;
        data["monthlyPayment"] = this.monthlyPayment;
        data["beneficiaryClauseCode"] = this.beneficiaryClauseCode;
        data["beneficiaryFreeClauseText"] = this.beneficiaryFreeClauseText;
        data["isDefaultBeneficiaryInheritance"] = this.isDefaultBeneficiaryInheritance;
        if (Array.isArray(this.beneficiaries)) {
            data["beneficiaries"] = [];
            for (let item of this.beneficiaries)
                data["beneficiaries"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGpaProfile {
    id?: number | undefined;
    isLaidOff?: boolean | undefined;
    isDysfunctional?: boolean | undefined;
    isOffWork?: boolean | undefined;
    isOnTreatment?: boolean | undefined;
    guaranteedCapitalCode?: number | undefined;
    isMultipliedCoverage?: boolean | undefined;
    monthlyPayment?: number | undefined;
    beneficiaryClauseCode?: number | undefined;
    beneficiaryFreeClauseText?: string | undefined;
    isDefaultBeneficiaryInheritance?: boolean | undefined;
    beneficiaries?: Beneficiary[] | undefined;
}

export class Beneficiary implements IBeneficiary {
    id?: number | undefined;
    person?: Person | undefined;
    relationTypeCode?: number | undefined;
    beneficialPart?: number | undefined;
    currentAddress?: Address | undefined;
    placeOfBirth?: Address | undefined;

    constructor(data?: IBeneficiary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : undefined as any;
            this.relationTypeCode = _data["relationTypeCode"];
            this.beneficialPart = _data["beneficialPart"];
            this.currentAddress = _data["currentAddress"] ? Address.fromJS(_data["currentAddress"]) : undefined as any;
            this.placeOfBirth = _data["placeOfBirth"] ? Address.fromJS(_data["placeOfBirth"]) : undefined as any;
        }
    }

    static fromJS(data: any): Beneficiary {
        data = typeof data === 'object' ? data : {};
        let result = new Beneficiary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["person"] = this.person ? this.person.toJSON() : undefined as any;
        data["relationTypeCode"] = this.relationTypeCode;
        data["beneficialPart"] = this.beneficialPart;
        data["currentAddress"] = this.currentAddress ? this.currentAddress.toJSON() : undefined as any;
        data["placeOfBirth"] = this.placeOfBirth ? this.placeOfBirth.toJSON() : undefined as any;
        return data;
    }
}

export interface IBeneficiary {
    id?: number | undefined;
    person?: Person | undefined;
    relationTypeCode?: number | undefined;
    beneficialPart?: number | undefined;
    currentAddress?: Address | undefined;
    placeOfBirth?: Address | undefined;
}

export class Address implements IAddress {
    country?: number | undefined;
    city?: string | undefined;
    zipCode?: string | undefined;
    addressLine?: string | undefined;
    additionalAddress?: string | undefined;
    additionalAddress2?: string | undefined;
    locality?: string | undefined;

    constructor(data?: IAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.country = _data["country"];
            this.city = _data["city"];
            this.zipCode = _data["zipCode"];
            this.addressLine = _data["addressLine"];
            this.additionalAddress = _data["additionalAddress"];
            this.additionalAddress2 = _data["additionalAddress2"];
            this.locality = _data["locality"];
        }
    }

    static fromJS(data: any): Address {
        data = typeof data === 'object' ? data : {};
        let result = new Address();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["country"] = this.country;
        data["city"] = this.city;
        data["zipCode"] = this.zipCode;
        data["addressLine"] = this.addressLine;
        data["additionalAddress"] = this.additionalAddress;
        data["additionalAddress2"] = this.additionalAddress2;
        data["locality"] = this.locality;
        return data;
    }
}

export interface IAddress {
    country?: number | undefined;
    city?: string | undefined;
    zipCode?: string | undefined;
    addressLine?: string | undefined;
    additionalAddress?: string | undefined;
    additionalAddress2?: string | undefined;
    locality?: string | undefined;
}

export class GfdProfile implements IGfdProfile {
    id?: number | undefined;
    isLaidOff?: boolean | undefined;
    isDysfunctional?: boolean | undefined;
    isOffWork?: boolean | undefined;
    isOnTreatment?: boolean | undefined;
    solutionTypeCode?: number | undefined;
    beneficiaryTypeCode?: number | undefined;
    guaranteedCapitalCode?: number | undefined;
    contributionTypeCode?: number | undefined;
    isDefaultBeneficiaryInheritance?: boolean | undefined;
    beneficiaries?: Beneficiary[] | undefined;

    constructor(data?: IGfdProfile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isLaidOff = _data["isLaidOff"];
            this.isDysfunctional = _data["isDysfunctional"];
            this.isOffWork = _data["isOffWork"];
            this.isOnTreatment = _data["isOnTreatment"];
            this.solutionTypeCode = _data["solutionTypeCode"];
            this.beneficiaryTypeCode = _data["beneficiaryTypeCode"];
            this.guaranteedCapitalCode = _data["guaranteedCapitalCode"];
            this.contributionTypeCode = _data["contributionTypeCode"];
            this.isDefaultBeneficiaryInheritance = _data["isDefaultBeneficiaryInheritance"];
            if (Array.isArray(_data["beneficiaries"])) {
                this.beneficiaries = [] as any;
                for (let item of _data["beneficiaries"])
                    this.beneficiaries!.push(Beneficiary.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GfdProfile {
        data = typeof data === 'object' ? data : {};
        let result = new GfdProfile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isLaidOff"] = this.isLaidOff;
        data["isDysfunctional"] = this.isDysfunctional;
        data["isOffWork"] = this.isOffWork;
        data["isOnTreatment"] = this.isOnTreatment;
        data["solutionTypeCode"] = this.solutionTypeCode;
        data["beneficiaryTypeCode"] = this.beneficiaryTypeCode;
        data["guaranteedCapitalCode"] = this.guaranteedCapitalCode;
        data["contributionTypeCode"] = this.contributionTypeCode;
        data["isDefaultBeneficiaryInheritance"] = this.isDefaultBeneficiaryInheritance;
        if (Array.isArray(this.beneficiaries)) {
            data["beneficiaries"] = [];
            for (let item of this.beneficiaries)
                data["beneficiaries"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGfdProfile {
    id?: number | undefined;
    isLaidOff?: boolean | undefined;
    isDysfunctional?: boolean | undefined;
    isOffWork?: boolean | undefined;
    isOnTreatment?: boolean | undefined;
    solutionTypeCode?: number | undefined;
    beneficiaryTypeCode?: number | undefined;
    guaranteedCapitalCode?: number | undefined;
    contributionTypeCode?: number | undefined;
    isDefaultBeneficiaryInheritance?: boolean | undefined;
    beneficiaries?: Beneficiary[] | undefined;
}

export class CimsProfile implements ICimsProfile {
    contractExpirationDate?: Date | undefined;
    primaryBeneficiary?: Beneficiary | undefined;

    constructor(data?: ICimsProfile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contractExpirationDate = _data["contractExpirationDate"] ? new Date(_data["contractExpirationDate"].toString()) : undefined as any;
            this.primaryBeneficiary = _data["primaryBeneficiary"] ? Beneficiary.fromJS(_data["primaryBeneficiary"]) : undefined as any;
        }
    }

    static fromJS(data: any): CimsProfile {
        data = typeof data === 'object' ? data : {};
        let result = new CimsProfile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contractExpirationDate"] = this.contractExpirationDate ? this.contractExpirationDate.toISOString() : undefined as any;
        data["primaryBeneficiary"] = this.primaryBeneficiary ? this.primaryBeneficiary.toJSON() : undefined as any;
        return data;
    }
}

export interface ICimsProfile {
    contractExpirationDate?: Date | undefined;
    primaryBeneficiary?: Beneficiary | undefined;
}

export class ProfessionalInfo implements IProfessionalInfo {
    sncfValue?: string | undefined;
    ratpValue?: string | undefined;
    personalMonthlyNetIncomeCode?: number | undefined;
    householdMonthlyNetIncomeCode?: number | undefined;
    professionalStatusCode?: number | undefined;
    activitySectorCode?: number | undefined;
    socialProfessionCategoryCode?: number | undefined;
    professionCode?: number | undefined;

    constructor(data?: IProfessionalInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sncfValue = _data["sncfValue"];
            this.ratpValue = _data["ratpValue"];
            this.personalMonthlyNetIncomeCode = _data["personalMonthlyNetIncomeCode"];
            this.householdMonthlyNetIncomeCode = _data["householdMonthlyNetIncomeCode"];
            this.professionalStatusCode = _data["professionalStatusCode"];
            this.activitySectorCode = _data["activitySectorCode"];
            this.socialProfessionCategoryCode = _data["socialProfessionCategoryCode"];
            this.professionCode = _data["professionCode"];
        }
    }

    static fromJS(data: any): ProfessionalInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ProfessionalInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sncfValue"] = this.sncfValue;
        data["ratpValue"] = this.ratpValue;
        data["personalMonthlyNetIncomeCode"] = this.personalMonthlyNetIncomeCode;
        data["householdMonthlyNetIncomeCode"] = this.householdMonthlyNetIncomeCode;
        data["professionalStatusCode"] = this.professionalStatusCode;
        data["activitySectorCode"] = this.activitySectorCode;
        data["socialProfessionCategoryCode"] = this.socialProfessionCategoryCode;
        data["professionCode"] = this.professionCode;
        return data;
    }
}

export interface IProfessionalInfo {
    sncfValue?: string | undefined;
    ratpValue?: string | undefined;
    personalMonthlyNetIncomeCode?: number | undefined;
    householdMonthlyNetIncomeCode?: number | undefined;
    professionalStatusCode?: number | undefined;
    activitySectorCode?: number | undefined;
    socialProfessionCategoryCode?: number | undefined;
    professionCode?: number | undefined;
}

export class ProfileQuestion implements IProfileQuestion {
    questionId?: number;
    answerId?: number;

    constructor(data?: IProfileQuestion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionId = _data["questionId"];
            this.answerId = _data["answerId"];
        }
    }

    static fromJS(data: any): ProfileQuestion {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileQuestion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionId"] = this.questionId;
        data["answerId"] = this.answerId;
        return data;
    }
}

export interface IProfileQuestion {
    questionId?: number;
    answerId?: number;
}

export class ProfileFund implements IProfileFund {
    fundId?: number;
    portion?: number | undefined;
    amount?: number | undefined;
    isinCode?: string;

    constructor(data?: IProfileFund) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fundId = _data["fundId"];
            this.portion = _data["portion"];
            this.amount = _data["amount"];
            this.isinCode = _data["isinCode"];
        }
    }

    static fromJS(data: any): ProfileFund {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileFund();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fundId"] = this.fundId;
        data["portion"] = this.portion;
        data["amount"] = this.amount;
        data["isinCode"] = this.isinCode;
        return data;
    }
}

export interface IProfileFund {
    fundId?: number;
    portion?: number | undefined;
    amount?: number | undefined;
    isinCode?: string;
}

export class ProfileDocument implements IProfileDocument {
    uniqueId?: string | undefined;
    documentTypeCode?: number;
    typeId?: number;
    file?: File | undefined;

    constructor(data?: IProfileDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.documentTypeCode = _data["documentTypeCode"];
            this.typeId = _data["typeId"];
            this.file = _data["file"] ? File.fromJS(_data["file"]) : undefined as any;
        }
    }

    static fromJS(data: any): ProfileDocument {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["documentTypeCode"] = this.documentTypeCode;
        data["typeId"] = this.typeId;
        data["file"] = this.file ? this.file.toJSON() : undefined as any;
        return data;
    }
}

export interface IProfileDocument {
    uniqueId?: string | undefined;
    documentTypeCode?: number;
    typeId?: number;
    file?: File | undefined;
}

export class File implements IFile {
    uniqueId?: string | undefined;
    fileName?: string;
    base64Content?: string;

    constructor(data?: IFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.fileName = _data["fileName"];
            this.base64Content = _data["base64Content"];
        }
    }

    static fromJS(data: any): File {
        data = typeof data === 'object' ? data : {};
        let result = new File();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["fileName"] = this.fileName;
        data["base64Content"] = this.base64Content;
        return data;
    }
}

export interface IFile {
    uniqueId?: string | undefined;
    fileName?: string;
    base64Content?: string;
}

export class ProofOfFund implements IProofOfFund {
    uniqueId?: string | undefined;
    typeId?: number;
    transactionDate?: Date | undefined;
    transactionAmount?: number | undefined;
    file?: File | undefined;

    constructor(data?: IProofOfFund) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.typeId = _data["typeId"];
            this.transactionDate = _data["transactionDate"] ? new Date(_data["transactionDate"].toString()) : undefined as any;
            this.transactionAmount = _data["transactionAmount"];
            this.file = _data["file"] ? File.fromJS(_data["file"]) : undefined as any;
        }
    }

    static fromJS(data: any): ProofOfFund {
        data = typeof data === 'object' ? data : {};
        let result = new ProofOfFund();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["typeId"] = this.typeId;
        data["transactionDate"] = this.transactionDate ? this.transactionDate.toISOString() : undefined as any;
        data["transactionAmount"] = this.transactionAmount;
        data["file"] = this.file ? this.file.toJSON() : undefined as any;
        return data;
    }
}

export interface IProofOfFund {
    uniqueId?: string | undefined;
    typeId?: number;
    transactionDate?: Date | undefined;
    transactionAmount?: number | undefined;
    file?: File | undefined;
}

export class AdvertisementSource implements IAdvertisementSource {
    advertisementSourceId?: number;
    advertisementSourceCode?: string | undefined;
    sponsorNumber?: string | undefined;
    memberNumber?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    partnerCode?: string | undefined;
    promoCode?: string | undefined;
    mifAdvisorCode?: string | undefined;
    utm?: string | undefined;

    constructor(data?: IAdvertisementSource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.advertisementSourceId = _data["advertisementSourceId"];
            this.advertisementSourceCode = _data["advertisementSourceCode"];
            this.sponsorNumber = _data["sponsorNumber"];
            this.memberNumber = _data["memberNumber"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.partnerCode = _data["partnerCode"];
            this.promoCode = _data["promoCode"];
            this.mifAdvisorCode = _data["mifAdvisorCode"];
            this.utm = _data["utm"];
        }
    }

    static fromJS(data: any): AdvertisementSource {
        data = typeof data === 'object' ? data : {};
        let result = new AdvertisementSource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["advertisementSourceId"] = this.advertisementSourceId;
        data["advertisementSourceCode"] = this.advertisementSourceCode;
        data["sponsorNumber"] = this.sponsorNumber;
        data["memberNumber"] = this.memberNumber;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["partnerCode"] = this.partnerCode;
        data["promoCode"] = this.promoCode;
        data["mifAdvisorCode"] = this.mifAdvisorCode;
        data["utm"] = this.utm;
        return data;
    }
}

export interface IAdvertisementSource {
    advertisementSourceId?: number;
    advertisementSourceCode?: string | undefined;
    sponsorNumber?: string | undefined;
    memberNumber?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    partnerCode?: string | undefined;
    promoCode?: string | undefined;
    mifAdvisorCode?: string | undefined;
    utm?: string | undefined;
}

export class Contact implements IContact {
    email?: string | undefined;
    phone?: string | undefined;
    mobilePhone?: string | undefined;
    receiveEmail?: boolean | undefined;
    receiveSms?: boolean | undefined;

    constructor(data?: IContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.mobilePhone = _data["mobilePhone"];
            this.receiveEmail = _data["receiveEmail"];
            this.receiveSms = _data["receiveSms"];
        }
    }

    static fromJS(data: any): Contact {
        data = typeof data === 'object' ? data : {};
        let result = new Contact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["mobilePhone"] = this.mobilePhone;
        data["receiveEmail"] = this.receiveEmail;
        data["receiveSms"] = this.receiveSms;
        return data;
    }
}

export interface IContact {
    email?: string | undefined;
    phone?: string | undefined;
    mobilePhone?: string | undefined;
    receiveEmail?: boolean | undefined;
    receiveSms?: boolean | undefined;
}

export class ProfileAssets implements IProfileAssets {
    proofOfWealthDescription?: string | undefined;
    proofOfWealthAssets?: number[] | undefined;
    proofOfFundsDescription?: string | undefined;
    proofOfFundsAssets?: number[] | undefined;

    constructor(data?: IProfileAssets) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.proofOfWealthDescription = _data["proofOfWealthDescription"];
            if (Array.isArray(_data["proofOfWealthAssets"])) {
                this.proofOfWealthAssets = [] as any;
                for (let item of _data["proofOfWealthAssets"])
                    this.proofOfWealthAssets!.push(item);
            }
            this.proofOfFundsDescription = _data["proofOfFundsDescription"];
            if (Array.isArray(_data["proofOfFundsAssets"])) {
                this.proofOfFundsAssets = [] as any;
                for (let item of _data["proofOfFundsAssets"])
                    this.proofOfFundsAssets!.push(item);
            }
        }
    }

    static fromJS(data: any): ProfileAssets {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileAssets();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["proofOfWealthDescription"] = this.proofOfWealthDescription;
        if (Array.isArray(this.proofOfWealthAssets)) {
            data["proofOfWealthAssets"] = [];
            for (let item of this.proofOfWealthAssets)
                data["proofOfWealthAssets"].push(item);
        }
        data["proofOfFundsDescription"] = this.proofOfFundsDescription;
        if (Array.isArray(this.proofOfFundsAssets)) {
            data["proofOfFundsAssets"] = [];
            for (let item of this.proofOfFundsAssets)
                data["proofOfFundsAssets"].push(item);
        }
        return data;
    }
}

export interface IProfileAssets {
    proofOfWealthDescription?: string | undefined;
    proofOfWealthAssets?: number[] | undefined;
    proofOfFundsDescription?: string | undefined;
    proofOfFundsAssets?: number[] | undefined;
}

export enum ProfileStatus {
    Active = 1,
    FirstNotice = 2,
    LastNotice = 3,
    Completed = 4,
    Blocked = 5,
    Archived = 6,
    Error = 7,
}

export class RetirementPlan implements IRetirementPlan {
    expectedRetirementDate?: Date | undefined;
    hasTaxDeduction?: boolean;

    constructor(data?: IRetirementPlan) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expectedRetirementDate = _data["expectedRetirementDate"] ? new Date(_data["expectedRetirementDate"].toString()) : undefined as any;
            this.hasTaxDeduction = _data["hasTaxDeduction"];
        }
    }

    static fromJS(data: any): RetirementPlan {
        data = typeof data === 'object' ? data : {};
        let result = new RetirementPlan();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expectedRetirementDate"] = this.expectedRetirementDate ? this.expectedRetirementDate.toISOString() : undefined as any;
        data["hasTaxDeduction"] = this.hasTaxDeduction;
        return data;
    }
}

export interface IRetirementPlan {
    expectedRetirementDate?: Date | undefined;
    hasTaxDeduction?: boolean;
}

export class SignatureTransactionResponse implements ISignatureTransactionResponse {
    transactionId?: string;
    signatoryId?: string;
    validationCode?: string;
    signedDocument?: string;
    signatureDate?: string;
    transactionEndDate?: string;
    apiError?: string;

    constructor(data?: ISignatureTransactionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionId = _data["transactionId"];
            this.signatoryId = _data["signatoryId"];
            this.validationCode = _data["validationCode"];
            this.signedDocument = _data["signedDocument"];
            this.signatureDate = _data["signatureDate"];
            this.transactionEndDate = _data["transactionEndDate"];
            this.apiError = _data["apiError"];
        }
    }

    static fromJS(data: any): SignatureTransactionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SignatureTransactionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionId"] = this.transactionId;
        data["signatoryId"] = this.signatoryId;
        data["validationCode"] = this.validationCode;
        data["signedDocument"] = this.signedDocument;
        data["signatureDate"] = this.signatureDate;
        data["transactionEndDate"] = this.transactionEndDate;
        data["apiError"] = this.apiError;
        return data;
    }
}

export interface ISignatureTransactionResponse {
    transactionId?: string;
    signatoryId?: string;
    validationCode?: string;
    signedDocument?: string;
    signatureDate?: string;
    transactionEndDate?: string;
    apiError?: string;
}

export class DocumentSignatureRequest implements IDocumentSignatureRequest {
    profileId?: string;
    phoneNumber?: string;
    htmlContent?: string;

    constructor(data?: IDocumentSignatureRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profileId = _data["profileId"];
            this.phoneNumber = _data["phoneNumber"];
            this.htmlContent = _data["htmlContent"];
        }
    }

    static fromJS(data: any): DocumentSignatureRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentSignatureRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profileId"] = this.profileId;
        data["phoneNumber"] = this.phoneNumber;
        data["htmlContent"] = this.htmlContent;
        return data;
    }
}

export interface IDocumentSignatureRequest {
    profileId?: string;
    phoneNumber?: string;
    htmlContent?: string;
}

export class RetrySigningDocumentRequest implements IRetrySigningDocumentRequest {
    profileId?: string;
    signatureId?: string;
    phoneNumber?: string;

    constructor(data?: IRetrySigningDocumentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profileId = _data["profileId"];
            this.signatureId = _data["signatureId"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): RetrySigningDocumentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RetrySigningDocumentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profileId"] = this.profileId;
        data["signatureId"] = this.signatureId;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface IRetrySigningDocumentRequest {
    profileId?: string;
    signatureId?: string;
    phoneNumber?: string;
}

export class SignatureTransactionRequest implements ISignatureTransactionRequest {
    profileId?: string;
    transactionId?: string;
    signatoryId?: string;
    validationCode?: string;

    constructor(data?: ISignatureTransactionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profileId = _data["profileId"];
            this.transactionId = _data["transactionId"];
            this.signatoryId = _data["signatoryId"];
            this.validationCode = _data["validationCode"];
        }
    }

    static fromJS(data: any): SignatureTransactionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SignatureTransactionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profileId"] = this.profileId;
        data["transactionId"] = this.transactionId;
        data["signatoryId"] = this.signatoryId;
        data["validationCode"] = this.validationCode;
        return data;
    }
}

export interface ISignatureTransactionRequest {
    profileId?: string;
    transactionId?: string;
    signatoryId?: string;
    validationCode?: string;
}

export abstract class BaseSecurityServiceDto implements IBaseSecurityServiceDto {
    profileId?: string;
    transactionId?: string;
    signatoryId?: string;
    error?: ApiError;
    isSuccessful?: boolean;

    constructor(data?: IBaseSecurityServiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profileId = _data["profileId"];
            this.transactionId = _data["transactionId"];
            this.signatoryId = _data["signatoryId"];
            this.error = _data["error"] ? ApiError.fromJS(_data["error"]) : undefined as any;
            this.isSuccessful = _data["isSuccessful"];
        }
    }

    static fromJS(data: any): BaseSecurityServiceDto {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseSecurityServiceDto' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profileId"] = this.profileId;
        data["transactionId"] = this.transactionId;
        data["signatoryId"] = this.signatoryId;
        data["error"] = this.error ? this.error.toJSON() : undefined as any;
        data["isSuccessful"] = this.isSuccessful;
        return data;
    }
}

export interface IBaseSecurityServiceDto {
    profileId?: string;
    transactionId?: string;
    signatoryId?: string;
    error?: ApiError;
    isSuccessful?: boolean;
}

export class SecurityServiceResponse extends BaseSecurityServiceDto implements ISecurityServiceResponse {
    transactionDate?: string;

    constructor(data?: ISecurityServiceResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.transactionDate = _data["transactionDate"];
        }
    }

    static override fromJS(data: any): SecurityServiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityServiceResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionDate"] = this.transactionDate;
        super.toJSON(data);
        return data;
    }
}

export interface ISecurityServiceResponse extends IBaseSecurityServiceDto {
    transactionDate?: string;
}

export class ApiError implements IApiError {
    code?: string;
    message?: string;

    constructor(data?: IApiError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ApiError {
        data = typeof data === 'object' ? data : {};
        let result = new ApiError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["message"] = this.message;
        return data;
    }
}

export interface IApiError {
    code?: string;
    message?: string;
}

export class ReSendOtpRequest implements IReSendOtpRequest {
    profileId?: string;
    signatoryId?: string;

    constructor(data?: IReSendOtpRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profileId = _data["profileId"];
            this.signatoryId = _data["signatoryId"];
        }
    }

    static fromJS(data: any): ReSendOtpRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ReSendOtpRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profileId"] = this.profileId;
        data["signatoryId"] = this.signatoryId;
        return data;
    }
}

export interface IReSendOtpRequest {
    profileId?: string;
    signatoryId?: string;
}

export class Label implements ILabel {
    sectionId?: number | undefined;
    name!: string;
    value!: string;
    updatedOn?: Date | undefined;
    isHidden?: boolean | undefined;

    constructor(data?: ILabel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sectionId = _data["sectionId"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : undefined as any;
            this.isHidden = _data["isHidden"];
        }
    }

    static fromJS(data: any): Label {
        data = typeof data === 'object' ? data : {};
        let result = new Label();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sectionId"] = this.sectionId;
        data["name"] = this.name;
        data["value"] = this.value;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : undefined as any;
        data["isHidden"] = this.isHidden;
        return data;
    }
}

export interface ILabel {
    sectionId?: number | undefined;
    name: string;
    value: string;
    updatedOn?: Date | undefined;
    isHidden?: boolean | undefined;
}

export class ReportFile implements IReportFile {
    name?: string;
    base64Content?: string;

    constructor(data?: IReportFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.base64Content = _data["base64Content"];
        }
    }

    static fromJS(data: any): ReportFile {
        data = typeof data === 'object' ? data : {};
        let result = new ReportFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["base64Content"] = this.base64Content;
        return data;
    }
}

export interface IReportFile {
    name?: string;
    base64Content?: string;
}

export class GpaConfiguration implements IGpaConfiguration {
    userTypes?: number[];
    minAge?: number;
    maxAge?: number;
    minInvestedAmount?: number;
    maxInvestedAmount?: number;
    gpaCost?: number;
    gpaGuaranteedCapital?: number;
    hasMultipliedCoverage?: boolean;

    constructor(data?: IGpaConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userTypes"])) {
                this.userTypes = [] as any;
                for (let item of _data["userTypes"])
                    this.userTypes!.push(item);
            }
            this.minAge = _data["minAge"];
            this.maxAge = _data["maxAge"];
            this.minInvestedAmount = _data["minInvestedAmount"];
            this.maxInvestedAmount = _data["maxInvestedAmount"];
            this.gpaCost = _data["gpaCost"];
            this.gpaGuaranteedCapital = _data["gpaGuaranteedCapital"];
            this.hasMultipliedCoverage = _data["hasMultipliedCoverage"];
        }
    }

    static fromJS(data: any): GpaConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new GpaConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userTypes)) {
            data["userTypes"] = [];
            for (let item of this.userTypes)
                data["userTypes"].push(item);
        }
        data["minAge"] = this.minAge;
        data["maxAge"] = this.maxAge;
        data["minInvestedAmount"] = this.minInvestedAmount;
        data["maxInvestedAmount"] = this.maxInvestedAmount;
        data["gpaCost"] = this.gpaCost;
        data["gpaGuaranteedCapital"] = this.gpaGuaranteedCapital;
        data["hasMultipliedCoverage"] = this.hasMultipliedCoverage;
        return data;
    }
}

export interface IGpaConfiguration {
    userTypes?: number[];
    minAge?: number;
    maxAge?: number;
    minInvestedAmount?: number;
    maxInvestedAmount?: number;
    gpaCost?: number;
    gpaGuaranteedCapital?: number;
    hasMultipliedCoverage?: boolean;
}

export class General implements IGeneral {
    originalWebSite?: string;
    gfdSite?: string;
    gpaSite?: string;
    cemsSite?: string;
    periSite?: string;
    cimsSite?: string;
    footerLinks?: Link[];

    constructor(data?: IGeneral) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.originalWebSite = _data["originalWebSite"];
            this.gfdSite = _data["gfdSite"];
            this.gpaSite = _data["gpaSite"];
            this.cemsSite = _data["cemsSite"];
            this.periSite = _data["periSite"];
            this.cimsSite = _data["cimsSite"];
            if (Array.isArray(_data["footerLinks"])) {
                this.footerLinks = [] as any;
                for (let item of _data["footerLinks"])
                    this.footerLinks!.push(Link.fromJS(item));
            }
        }
    }

    static fromJS(data: any): General {
        data = typeof data === 'object' ? data : {};
        let result = new General();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["originalWebSite"] = this.originalWebSite;
        data["gfdSite"] = this.gfdSite;
        data["gpaSite"] = this.gpaSite;
        data["cemsSite"] = this.cemsSite;
        data["periSite"] = this.periSite;
        data["cimsSite"] = this.cimsSite;
        if (Array.isArray(this.footerLinks)) {
            data["footerLinks"] = [];
            for (let item of this.footerLinks)
                data["footerLinks"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGeneral {
    originalWebSite?: string;
    gfdSite?: string;
    gpaSite?: string;
    cemsSite?: string;
    periSite?: string;
    cimsSite?: string;
    footerLinks?: Link[];
}

export class Link implements ILink {
    label?: string;
    typeCode?: string;
    value?: string;

    constructor(data?: ILink) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.typeCode = _data["typeCode"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): Link {
        data = typeof data === 'object' ? data : {};
        let result = new Link();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["typeCode"] = this.typeCode;
        data["value"] = this.value;
        return data;
    }
}

export interface ILink {
    label?: string;
    typeCode?: string;
    value?: string;
}

export class ExternalServices implements IExternalServices {
    adviceIdentifier?: string;
    gtmIdentifier?: string;
    dqeValidation?: boolean;
    dqeAutoCompletion?: boolean;

    constructor(data?: IExternalServices) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.adviceIdentifier = _data["adviceIdentifier"];
            this.gtmIdentifier = _data["gtmIdentifier"];
            this.dqeValidation = _data["dqeValidation"];
            this.dqeAutoCompletion = _data["dqeAutoCompletion"];
        }
    }

    static fromJS(data: any): ExternalServices {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalServices();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adviceIdentifier"] = this.adviceIdentifier;
        data["gtmIdentifier"] = this.gtmIdentifier;
        data["dqeValidation"] = this.dqeValidation;
        data["dqeAutoCompletion"] = this.dqeAutoCompletion;
        return data;
    }
}

export interface IExternalServices {
    adviceIdentifier?: string;
    gtmIdentifier?: string;
    dqeValidation?: boolean;
    dqeAutoCompletion?: boolean;
}

export class Subscription implements ISubscription {
    expirationPeriod?: number;
    defaultCountryCode?: string;
    defaultNationalityCode?: string;

    constructor(data?: ISubscription) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expirationPeriod = _data["expirationPeriod"];
            this.defaultCountryCode = _data["defaultCountryCode"];
            this.defaultNationalityCode = _data["defaultNationalityCode"];
        }
    }

    static fromJS(data: any): Subscription {
        data = typeof data === 'object' ? data : {};
        let result = new Subscription();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expirationPeriod"] = this.expirationPeriod;
        data["defaultCountryCode"] = this.defaultCountryCode;
        data["defaultNationalityCode"] = this.defaultNationalityCode;
        return data;
    }
}

export interface ISubscription {
    expirationPeriod?: number;
    defaultCountryCode?: string;
    defaultNationalityCode?: string;
}

export class Beneficiaries implements IBeneficiaries {
    maxNumberOfBeneficiaries?: number;
    cimsMaxNumberOfBeneficiaries?: number;
    maxNumberOfCharacters?: number;
    maxNumberOfLines?: number;

    constructor(data?: IBeneficiaries) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxNumberOfBeneficiaries = _data["maxNumberOfBeneficiaries"];
            this.cimsMaxNumberOfBeneficiaries = _data["cimsMaxNumberOfBeneficiaries"];
            this.maxNumberOfCharacters = _data["maxNumberOfCharacters"];
            this.maxNumberOfLines = _data["maxNumberOfLines"];
        }
    }

    static fromJS(data: any): Beneficiaries {
        data = typeof data === 'object' ? data : {};
        let result = new Beneficiaries();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxNumberOfBeneficiaries"] = this.maxNumberOfBeneficiaries;
        data["cimsMaxNumberOfBeneficiaries"] = this.cimsMaxNumberOfBeneficiaries;
        data["maxNumberOfCharacters"] = this.maxNumberOfCharacters;
        data["maxNumberOfLines"] = this.maxNumberOfLines;
        return data;
    }
}

export interface IBeneficiaries {
    maxNumberOfBeneficiaries?: number;
    cimsMaxNumberOfBeneficiaries?: number;
    maxNumberOfCharacters?: number;
    maxNumberOfLines?: number;
}

export class Summary implements ISummary {
    possibleChoices?: Choice[];

    constructor(data?: ISummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["possibleChoices"])) {
                this.possibleChoices = [] as any;
                for (let item of _data["possibleChoices"])
                    this.possibleChoices!.push(Choice.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Summary {
        data = typeof data === 'object' ? data : {};
        let result = new Summary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.possibleChoices)) {
            data["possibleChoices"] = [];
            for (let item of this.possibleChoices)
                data["possibleChoices"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISummary {
    possibleChoices?: Choice[];
}

export class Choice implements IChoice {
    code?: string;
    label?: string;

    constructor(data?: IChoice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): Choice {
        data = typeof data === 'object' ? data : {};
        let result = new Choice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["label"] = this.label;
        return data;
    }
}

export interface IChoice {
    code?: string;
    label?: string;
}

export class SepaMandate implements ISepaMandate {
    creditorIdentifier?: string;
    creditorName?: string;
    creditorOrganization?: string;

    constructor(data?: ISepaMandate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.creditorIdentifier = _data["creditorIdentifier"];
            this.creditorName = _data["creditorName"];
            this.creditorOrganization = _data["creditorOrganization"];
        }
    }

    static fromJS(data: any): SepaMandate {
        data = typeof data === 'object' ? data : {};
        let result = new SepaMandate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creditorIdentifier"] = this.creditorIdentifier;
        data["creditorName"] = this.creditorName;
        data["creditorOrganization"] = this.creditorOrganization;
        return data;
    }
}

export interface ISepaMandate {
    creditorIdentifier?: string;
    creditorName?: string;
    creditorOrganization?: string;
}

export class Emails implements IEmails {
    firstEmailNoticeDelay?: number;
    firstNoticeValueType?: TimeSpanType;
    secondEmailNoticeDelay?: number;
    secondNoticeValueType?: TimeSpanType;

    constructor(data?: IEmails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstEmailNoticeDelay = _data["firstEmailNoticeDelay"];
            this.firstNoticeValueType = _data["firstNoticeValueType"];
            this.secondEmailNoticeDelay = _data["secondEmailNoticeDelay"];
            this.secondNoticeValueType = _data["secondNoticeValueType"];
        }
    }

    static fromJS(data: any): Emails {
        data = typeof data === 'object' ? data : {};
        let result = new Emails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstEmailNoticeDelay"] = this.firstEmailNoticeDelay;
        data["firstNoticeValueType"] = this.firstNoticeValueType;
        data["secondEmailNoticeDelay"] = this.secondEmailNoticeDelay;
        data["secondNoticeValueType"] = this.secondNoticeValueType;
        return data;
    }
}

export interface IEmails {
    firstEmailNoticeDelay?: number;
    firstNoticeValueType?: TimeSpanType;
    secondEmailNoticeDelay?: number;
    secondNoticeValueType?: TimeSpanType;
}

export enum TimeSpanType {
    Day = 1,
    Hour = 2,
    Minute = 3,
}

export class Questionnaire implements IQuestionnaire {
    ageScores?: AgeScore[];

    constructor(data?: IQuestionnaire) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ageScores"])) {
                this.ageScores = [] as any;
                for (let item of _data["ageScores"])
                    this.ageScores!.push(AgeScore.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Questionnaire {
        data = typeof data === 'object' ? data : {};
        let result = new Questionnaire();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ageScores)) {
            data["ageScores"] = [];
            for (let item of this.ageScores)
                data["ageScores"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IQuestionnaire {
    ageScores?: AgeScore[];
}

export class AgeScore implements IAgeScore {
    minAge?: number;
    maxAge?: number;
    score?: number;

    constructor(data?: IAgeScore) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.minAge = _data["minAge"];
            this.maxAge = _data["maxAge"];
            this.score = _data["score"];
        }
    }

    static fromJS(data: any): AgeScore {
        data = typeof data === 'object' ? data : {};
        let result = new AgeScore();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minAge"] = this.minAge;
        data["maxAge"] = this.maxAge;
        data["score"] = this.score;
        return data;
    }
}

export interface IAgeScore {
    minAge?: number;
    maxAge?: number;
    score?: number;
}

export class DefaultProductTabs implements IDefaultProductTabs {
    tabs?: ProductTab[];

    constructor(data?: IDefaultProductTabs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tabs"])) {
                this.tabs = [] as any;
                for (let item of _data["tabs"])
                    this.tabs!.push(ProductTab.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DefaultProductTabs {
        data = typeof data === 'object' ? data : {};
        let result = new DefaultProductTabs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tabs)) {
            data["tabs"] = [];
            for (let item of this.tabs)
                data["tabs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDefaultProductTabs {
    tabs?: ProductTab[];
}

export class ProductTab implements IProductTab {
    productId?: number;
    tabId?: number;

    constructor(data?: IProductTab) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.tabId = _data["tabId"];
        }
    }

    static fromJS(data: any): ProductTab {
        data = typeof data === 'object' ? data : {};
        let result = new ProductTab();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["tabId"] = this.tabId;
        return data;
    }
}

export interface IProductTab {
    productId?: number;
    tabId?: number;
}

export class ProductTabs implements IProductTabs {
    tabs?: ProductTab[];

    constructor(data?: IProductTabs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tabs"])) {
                this.tabs = [] as any;
                for (let item of _data["tabs"])
                    this.tabs!.push(ProductTab.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductTabs {
        data = typeof data === 'object' ? data : {};
        let result = new ProductTabs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tabs)) {
            data["tabs"] = [];
            for (let item of this.tabs)
                data["tabs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProductTabs {
    tabs?: ProductTab[];
}

export class Payments implements IPayments {
    freePaymentMax?: number;
    scheduledPaymentMax?: number;

    constructor(data?: IPayments) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.freePaymentMax = _data["freePaymentMax"];
            this.scheduledPaymentMax = _data["scheduledPaymentMax"];
        }
    }

    static fromJS(data: any): Payments {
        data = typeof data === 'object' ? data : {};
        let result = new Payments();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["freePaymentMax"] = this.freePaymentMax;
        data["scheduledPaymentMax"] = this.scheduledPaymentMax;
        return data;
    }
}

export interface IPayments {
    freePaymentMax?: number;
    scheduledPaymentMax?: number;
}

export class ContractTransfer implements IContractTransfer {
    authorizeFullPayment?: boolean;
    fullPaymentMaximum?: number;

    constructor(data?: IContractTransfer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authorizeFullPayment = _data["authorizeFullPayment"];
            this.fullPaymentMaximum = _data["fullPaymentMaximum"];
        }
    }

    static fromJS(data: any): ContractTransfer {
        data = typeof data === 'object' ? data : {};
        let result = new ContractTransfer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authorizeFullPayment"] = this.authorizeFullPayment;
        data["fullPaymentMaximum"] = this.fullPaymentMaximum;
        return data;
    }
}

export interface IContractTransfer {
    authorizeFullPayment?: boolean;
    fullPaymentMaximum?: number;
}

export class FundsOrigin implements IFundsOrigin {
    minPayment?: number;
    minPaymentWithEstate?: number;

    constructor(data?: IFundsOrigin) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.minPayment = _data["minPayment"];
            this.minPaymentWithEstate = _data["minPaymentWithEstate"];
        }
    }

    static fromJS(data: any): FundsOrigin {
        data = typeof data === 'object' ? data : {};
        let result = new FundsOrigin();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minPayment"] = this.minPayment;
        data["minPaymentWithEstate"] = this.minPaymentWithEstate;
        return data;
    }
}

export interface IFundsOrigin {
    minPayment?: number;
    minPaymentWithEstate?: number;
}

export class SubscriptionWithdrawal implements ISubscriptionWithdrawal {
    actionDelay?: number;
    delayValueType?: TimeSpanType;
    triggerType?: number;

    constructor(data?: ISubscriptionWithdrawal) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actionDelay = _data["actionDelay"];
            this.delayValueType = _data["delayValueType"];
            this.triggerType = _data["triggerType"];
        }
    }

    static fromJS(data: any): SubscriptionWithdrawal {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionWithdrawal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionDelay"] = this.actionDelay;
        data["delayValueType"] = this.delayValueType;
        data["triggerType"] = this.triggerType;
        return data;
    }
}

export interface ISubscriptionWithdrawal {
    actionDelay?: number;
    delayValueType?: TimeSpanType;
    triggerType?: number;
}

export class EmailTemplate implements IEmailTemplate {
    templateId?: number;
    productType?: ProductType | undefined;
    subject?: string;
    html?: string;
    updatedOn?: Date | undefined;

    constructor(data?: IEmailTemplate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.templateId = _data["templateId"];
            this.productType = _data["productType"];
            this.subject = _data["subject"];
            this.html = _data["html"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): EmailTemplate {
        data = typeof data === 'object' ? data : {};
        let result = new EmailTemplate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateId"] = this.templateId;
        data["productType"] = this.productType;
        data["subject"] = this.subject;
        data["html"] = this.html;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : undefined as any;
        return data;
    }
}

export interface IEmailTemplate {
    templateId?: number;
    productType?: ProductType | undefined;
    subject?: string;
    html?: string;
    updatedOn?: Date | undefined;
}

export enum ProductType {
    Cems = 1,
    Gpa = 2,
    Gfd = 3,
    Peri = 4,
    Cims = 5,
}

export class AssociatedQuestion implements IAssociatedQuestion {
    questionId?: number;
    answerId?: number;
    inconsistentQuestionId?: number;
    inconsistentAnswerId?: number;

    constructor(data?: IAssociatedQuestion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionId = _data["questionId"];
            this.answerId = _data["answerId"];
            this.inconsistentQuestionId = _data["inconsistentQuestionId"];
            this.inconsistentAnswerId = _data["inconsistentAnswerId"];
        }
    }

    static fromJS(data: any): AssociatedQuestion {
        data = typeof data === 'object' ? data : {};
        let result = new AssociatedQuestion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionId"] = this.questionId;
        data["answerId"] = this.answerId;
        data["inconsistentQuestionId"] = this.inconsistentQuestionId;
        data["inconsistentAnswerId"] = this.inconsistentAnswerId;
        return data;
    }
}

export interface IAssociatedQuestion {
    questionId?: number;
    answerId?: number;
    inconsistentQuestionId?: number;
    inconsistentAnswerId?: number;
}

export class InvestmentLimits implements IInvestmentLimits {
    limits?: InvestmentLimit[];

    constructor(data?: IInvestmentLimits) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["limits"])) {
                this.limits = [] as any;
                for (let item of _data["limits"])
                    this.limits!.push(InvestmentLimit.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InvestmentLimits {
        data = typeof data === 'object' ? data : {};
        let result = new InvestmentLimits();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.limits)) {
            data["limits"] = [];
            for (let item of this.limits)
                data["limits"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInvestmentLimits {
    limits?: InvestmentLimit[];
}

export class InvestmentLimit implements IInvestmentLimit {
    productId?: number;
    limit?: number;

    constructor(data?: IInvestmentLimit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.limit = _data["limit"];
        }
    }

    static fromJS(data: any): InvestmentLimit {
        data = typeof data === 'object' ? data : {};
        let result = new InvestmentLimit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["limit"] = this.limit;
        return data;
    }
}

export interface IInvestmentLimit {
    productId?: number;
    limit?: number;
}

export class OfferStatus implements IOfferStatus {
    id?: number;
    label?: string;
    isTimeLimited?: boolean;

    constructor(data?: IOfferStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.label = _data["label"];
            this.isTimeLimited = _data["isTimeLimited"];
        }
    }

    static fromJS(data: any): OfferStatus {
        data = typeof data === 'object' ? data : {};
        let result = new OfferStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["label"] = this.label;
        data["isTimeLimited"] = this.isTimeLimited;
        return data;
    }
}

export interface IOfferStatus {
    id?: number;
    label?: string;
    isTimeLimited?: boolean;
}

export class Product implements IProduct {
    id?: number;
    label?: string;

    constructor(data?: IProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): Product {
        data = typeof data === 'object' ? data : {};
        let result = new Product();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["label"] = this.label;
        return data;
    }
}

export interface IProduct {
    id?: number;
    label?: string;
}

export class Section implements ISection {
    id?: number;
    name?: string;
    displayName?: string;

    constructor(data?: ISection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): Section {
        data = typeof data === 'object' ? data : {};
        let result = new Section();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ISection {
    id?: number;
    name?: string;
    displayName?: string;
}

export enum GroupType {
    Label = 1,
    Offer = 2,
}

export class ConditionType implements IConditionType {
    id?: number;
    label?: string;
    hasOptions?: boolean;

    constructor(data?: IConditionType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.label = _data["label"];
            this.hasOptions = _data["hasOptions"];
        }
    }

    static fromJS(data: any): ConditionType {
        data = typeof data === 'object' ? data : {};
        let result = new ConditionType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["label"] = this.label;
        data["hasOptions"] = this.hasOptions;
        return data;
    }
}

export interface IConditionType {
    id?: number;
    label?: string;
    hasOptions?: boolean;
}

export class OptionValue implements IOptionValue {
    id?: number;
    conditionTypeId?: number;
    label?: string;

    constructor(data?: IOptionValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.conditionTypeId = _data["conditionTypeId"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): OptionValue {
        data = typeof data === 'object' ? data : {};
        let result = new OptionValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["conditionTypeId"] = this.conditionTypeId;
        data["label"] = this.label;
        return data;
    }
}

export interface IOptionValue {
    id?: number;
    conditionTypeId?: number;
    label?: string;
}

export class WithdrawnSubscriptionsResponse implements IWithdrawnSubscriptionsResponse {
    periodInDays?: number;
    withdrawnProfiles?: WithdrawnProfile[];

    constructor(data?: IWithdrawnSubscriptionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.periodInDays = _data["periodInDays"];
            if (Array.isArray(_data["withdrawnProfiles"])) {
                this.withdrawnProfiles = [] as any;
                for (let item of _data["withdrawnProfiles"])
                    this.withdrawnProfiles!.push(WithdrawnProfile.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WithdrawnSubscriptionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WithdrawnSubscriptionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["periodInDays"] = this.periodInDays;
        if (Array.isArray(this.withdrawnProfiles)) {
            data["withdrawnProfiles"] = [];
            for (let item of this.withdrawnProfiles)
                data["withdrawnProfiles"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IWithdrawnSubscriptionsResponse {
    periodInDays?: number;
    withdrawnProfiles?: WithdrawnProfile[];
}

export class WithdrawnProfile implements IWithdrawnProfile {
    crmIdentityNumber?: string | undefined;
    lastName?: string | undefined;
    firstName?: string | undefined;
    productType?: string | undefined;
    source?: string | undefined;
    partnerCode?: string | undefined;
    promoCode?: string | undefined;
    paymentAmount?: number | undefined;
    abandonmentStep?: string | undefined;
    abandonmentDate?: Date | undefined;

    constructor(data?: IWithdrawnProfile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.crmIdentityNumber = _data["crmIdentityNumber"];
            this.lastName = _data["lastName"];
            this.firstName = _data["firstName"];
            this.productType = _data["productType"];
            this.source = _data["source"];
            this.partnerCode = _data["partnerCode"];
            this.promoCode = _data["promoCode"];
            this.paymentAmount = _data["paymentAmount"];
            this.abandonmentStep = _data["abandonmentStep"];
            this.abandonmentDate = _data["abandonmentDate"] ? new Date(_data["abandonmentDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): WithdrawnProfile {
        data = typeof data === 'object' ? data : {};
        let result = new WithdrawnProfile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["crmIdentityNumber"] = this.crmIdentityNumber;
        data["lastName"] = this.lastName;
        data["firstName"] = this.firstName;
        data["productType"] = this.productType;
        data["source"] = this.source;
        data["partnerCode"] = this.partnerCode;
        data["promoCode"] = this.promoCode;
        data["paymentAmount"] = this.paymentAmount;
        data["abandonmentStep"] = this.abandonmentStep;
        data["abandonmentDate"] = this.abandonmentDate ? this.abandonmentDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IWithdrawnProfile {
    crmIdentityNumber?: string | undefined;
    lastName?: string | undefined;
    firstName?: string | undefined;
    productType?: string | undefined;
    source?: string | undefined;
    partnerCode?: string | undefined;
    promoCode?: string | undefined;
    paymentAmount?: number | undefined;
    abandonmentStep?: string | undefined;
    abandonmentDate?: Date | undefined;
}

export class Offer implements IOffer {
    id?: number | undefined;
    statusId?: number;
    name?: string;
    promoCode?: string;
    priority?: number;
    createdOn?: Date | undefined;
    updatedOn?: Date | undefined;
    statusStartDate?: Date | undefined;
    statusEndDate?: Date | undefined;
    products?: number[];
    description?: OfferDescription;
    conditions?: OfferCondition[];
    sections?: OfferSection[];
    rate?: number | undefined;
    paymentCharges?: number | undefined;

    constructor(data?: IOffer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.statusId = _data["statusId"];
            this.name = _data["name"];
            this.promoCode = _data["promoCode"];
            this.priority = _data["priority"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : undefined as any;
            this.statusStartDate = _data["statusStartDate"] ? new Date(_data["statusStartDate"].toString()) : undefined as any;
            this.statusEndDate = _data["statusEndDate"] ? new Date(_data["statusEndDate"].toString()) : undefined as any;
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(item);
            }
            this.description = _data["description"] ? OfferDescription.fromJS(_data["description"]) : undefined as any;
            if (Array.isArray(_data["conditions"])) {
                this.conditions = [] as any;
                for (let item of _data["conditions"])
                    this.conditions!.push(OfferCondition.fromJS(item));
            }
            if (Array.isArray(_data["sections"])) {
                this.sections = [] as any;
                for (let item of _data["sections"])
                    this.sections!.push(OfferSection.fromJS(item));
            }
            this.rate = _data["rate"];
            this.paymentCharges = _data["paymentCharges"];
        }
    }

    static fromJS(data: any): Offer {
        data = typeof data === 'object' ? data : {};
        let result = new Offer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["statusId"] = this.statusId;
        data["name"] = this.name;
        data["promoCode"] = this.promoCode;
        data["priority"] = this.priority;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : undefined as any;
        data["statusStartDate"] = this.statusStartDate ? this.statusStartDate.toISOString() : undefined as any;
        data["statusEndDate"] = this.statusEndDate ? this.statusEndDate.toISOString() : undefined as any;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item);
        }
        data["description"] = this.description ? this.description.toJSON() : undefined as any;
        if (Array.isArray(this.conditions)) {
            data["conditions"] = [];
            for (let item of this.conditions)
                data["conditions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.sections)) {
            data["sections"] = [];
            for (let item of this.sections)
                data["sections"].push(item ? item.toJSON() : undefined as any);
        }
        data["rate"] = this.rate;
        data["paymentCharges"] = this.paymentCharges;
        return data;
    }
}

export interface IOffer {
    id?: number | undefined;
    statusId?: number;
    name?: string;
    promoCode?: string;
    priority?: number;
    createdOn?: Date | undefined;
    updatedOn?: Date | undefined;
    statusStartDate?: Date | undefined;
    statusEndDate?: Date | undefined;
    products?: number[];
    description?: OfferDescription;
    conditions?: OfferCondition[];
    sections?: OfferSection[];
    rate?: number | undefined;
    paymentCharges?: number | undefined;
}

export class OfferDescription implements IOfferDescription {
    text?: string;
    membershipForm?: string;
    generalConditions?: string;

    constructor(data?: IOfferDescription) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
            this.membershipForm = _data["membershipForm"];
            this.generalConditions = _data["generalConditions"];
        }
    }

    static fromJS(data: any): OfferDescription {
        data = typeof data === 'object' ? data : {};
        let result = new OfferDescription();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["membershipForm"] = this.membershipForm;
        data["generalConditions"] = this.generalConditions;
        return data;
    }
}

export interface IOfferDescription {
    text?: string;
    membershipForm?: string;
    generalConditions?: string;
}

export class OfferCondition implements IOfferCondition {
    id?: number | undefined;
    conditionTypeId?: number;
    code?: string;
    value?: string;

    constructor(data?: IOfferCondition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.conditionTypeId = _data["conditionTypeId"];
            this.code = _data["code"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): OfferCondition {
        data = typeof data === 'object' ? data : {};
        let result = new OfferCondition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["conditionTypeId"] = this.conditionTypeId;
        data["code"] = this.code;
        data["value"] = this.value;
        return data;
    }
}

export interface IOfferCondition {
    id?: number | undefined;
    conditionTypeId?: number;
    code?: string;
    value?: string;
}

export class OfferSection implements IOfferSection {
    id?: number | undefined;
    sectionId?: number;
    sectionName?: string;
    overrideOfferText?: boolean;
    overrideConditions?: boolean;
    offerText?: string;
    conditions?: OfferCondition[];

    constructor(data?: IOfferSection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sectionId = _data["sectionId"];
            this.sectionName = _data["sectionName"];
            this.overrideOfferText = _data["overrideOfferText"];
            this.overrideConditions = _data["overrideConditions"];
            this.offerText = _data["offerText"];
            if (Array.isArray(_data["conditions"])) {
                this.conditions = [] as any;
                for (let item of _data["conditions"])
                    this.conditions!.push(OfferCondition.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OfferSection {
        data = typeof data === 'object' ? data : {};
        let result = new OfferSection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sectionId"] = this.sectionId;
        data["sectionName"] = this.sectionName;
        data["overrideOfferText"] = this.overrideOfferText;
        data["overrideConditions"] = this.overrideConditions;
        data["offerText"] = this.offerText;
        if (Array.isArray(this.conditions)) {
            data["conditions"] = [];
            for (let item of this.conditions)
                data["conditions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IOfferSection {
    id?: number | undefined;
    sectionId?: number;
    sectionName?: string;
    overrideOfferText?: boolean;
    overrideConditions?: boolean;
    offerText?: string;
    conditions?: OfferCondition[];
}

export class ChangeHistory implements IChangeHistory {
    userName?: string;
    type?: string;
    tableName?: string;
    columnName?: string;
    oldValue?: any;
    newValue?: any;
    createdOn?: Date;

    constructor(data?: IChangeHistory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.type = _data["type"];
            this.tableName = _data["tableName"];
            this.columnName = _data["columnName"];
            this.oldValue = _data["oldValue"];
            this.newValue = _data["newValue"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ChangeHistory {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeHistory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["type"] = this.type;
        data["tableName"] = this.tableName;
        data["columnName"] = this.columnName;
        data["oldValue"] = this.oldValue;
        data["newValue"] = this.newValue;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        return data;
    }
}

export interface IChangeHistory {
    userName?: string;
    type?: string;
    tableName?: string;
    columnName?: string;
    oldValue?: any;
    newValue?: any;
    createdOn?: Date;
}

export class PortfolioPerformance implements IPortfolioPerformance {
    managementTypeId?: number;
    productTypeId?: number;
    profileTypeId?: number;
    year?: number | undefined;
    range?: number | undefined;
    value?: number;

    constructor(data?: IPortfolioPerformance) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.managementTypeId = _data["managementTypeId"];
            this.productTypeId = _data["productTypeId"];
            this.profileTypeId = _data["profileTypeId"];
            this.year = _data["year"];
            this.range = _data["range"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): PortfolioPerformance {
        data = typeof data === 'object' ? data : {};
        let result = new PortfolioPerformance();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["managementTypeId"] = this.managementTypeId;
        data["productTypeId"] = this.productTypeId;
        data["profileTypeId"] = this.profileTypeId;
        data["year"] = this.year;
        data["range"] = this.range;
        data["value"] = this.value;
        return data;
    }
}

export interface IPortfolioPerformance {
    managementTypeId?: number;
    productTypeId?: number;
    profileTypeId?: number;
    year?: number | undefined;
    range?: number | undefined;
    value?: number;
}

function formatDate(d: Date) {
    return d.getFullYear() + '-' + 
        (d.getMonth() < 9 ? ('0' + (d.getMonth()+1)) : (d.getMonth()+1)) + '-' +
        (d.getDate() < 10 ? ('0' + d.getDate()) : d.getDate());
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}